var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _g, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 359,
    viewBox: "0 0 428 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343.172 92.7812L337.744 102.179L343.172 111.577H353.966L359.394 102.179L353.966 92.7812H343.172Z",
    fill: "#026CE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.419 102.473L321.001 111.86L326.419 121.258H337.212L342.641 111.86L337.212 102.473H326.419Z",
    fill: "#026CE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309.676 112.15L304.248 121.548L309.676 130.946H320.469L325.898 121.548L320.469 112.15H309.676Z",
    fill: "#026CE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M292.923 102.473L287.505 111.86L292.923 121.258H303.716L309.144 111.86L303.716 102.473H292.923Z",
    fill: "#026CE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M370.718 121.258L376.136 111.86L370.718 102.473H359.914L354.497 111.86L359.914 121.258H370.718Z",
    fill: "#026CE3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M387.461 111.577L389.201 108.566C388.934 103.25 388.199 97.9677 387.003 92.7812H376.667L371.239 102.158L376.667 111.535L387.461 111.577Z",
    fill: "#026CE3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M353.966 130.946L359.394 121.548L353.966 112.15H343.172L337.744 121.548L343.172 130.946H353.966Z",
    fill: "#026CE3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M359.914 83.1035L354.497 92.4908L359.914 101.888H370.718L376.136 92.4908L370.718 83.1035H359.914Z",
    fill: "#026CE3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M371.239 82.8104L376.667 92.1872H386.867C385.26 85.703 382.947 79.4143 379.97 73.4336H376.667L371.239 82.8104Z",
    fill: "#026CE3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.938 102.473L153.52 111.86L158.938 121.258H169.742L175.16 111.86L169.742 102.473H158.938Z",
    fill: "#026CE3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M337.212 121.84H326.419L321.001 131.227L326.419 140.625H337.212L342.641 131.227L337.212 121.84Z",
    fill: "#026CE3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M192.434 102.473L187.016 111.86L192.434 121.258H203.238L208.656 111.86L203.238 102.473H192.434Z",
    fill: "#026CE3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M175.691 92.7812L170.263 102.179L175.691 111.577H186.485L191.913 102.179L186.485 92.7812H175.691Z",
    fill: "#026CE3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.442 83.1035L120.024 92.4908L125.442 101.888H136.246L141.664 92.4908L136.246 83.1035H125.442Z",
    fill: "#026CE3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 92.7812L136.767 102.179L142.195 111.577H152.989L158.417 102.179L152.989 92.7812H142.195Z",
    fill: "#026CE3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M225.93 121.84L220.512 131.227L225.93 140.625H236.724L242.152 131.227L236.724 121.84H225.93Z",
    fill: "#026CE3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M242.684 112.15L237.255 121.548L242.684 130.946H253.477L258.905 121.548L253.477 112.15H242.684Z",
    fill: "#026CE3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.426 121.84L254.008 131.227L259.426 140.625H270.23L275.648 131.227L270.23 121.84H259.426Z",
    fill: "#026CE3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M276.18 112.15L270.751 121.548L276.18 130.946H286.973L292.402 121.548L286.973 112.15H276.18Z",
    fill: "#026CE3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M209.187 112.15L203.759 121.548L209.187 130.946H219.981L225.409 121.548L219.981 112.15H209.187Z",
    fill: "#026CE3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M320.469 189.623H309.676L304.248 199.021L309.676 208.418H320.469L325.898 199.021L320.469 189.623Z",
    fill: "#026CE3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M119.493 227.786L124.921 218.388L119.493 208.99H108.699L103.271 218.388L108.699 227.786H119.493Z",
    fill: "#026CE3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M136.246 218.097L141.664 208.71L136.246 199.312H125.442L120.024 208.71L125.442 218.097H136.246Z",
    fill: "#026CE3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M152.989 208.418L158.417 199.021L152.989 189.623H142.195L136.767 199.021L142.195 208.418H152.989Z",
    fill: "#026CE3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M169.742 198.73L175.16 189.343L169.742 179.945H158.938L153.52 189.343L158.938 198.73H169.742Z",
    fill: "#026CE3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M186.485 208.418L191.913 199.021L186.485 189.623H175.691L170.263 199.021L175.691 208.418H186.485Z",
    fill: "#026CE3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 227.786L91.425 218.388L85.9968 208.99H75.203L69.7749 218.388L75.203 227.786H85.9968Z",
    fill: "#026CE3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.75 218.097L108.167 208.71L102.75 199.312H91.9455L86.5278 208.71L91.9455 218.097H102.75Z",
    fill: "#026CE3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7065 227.786H52.5002L57.9284 218.388L52.5002 208.99H41.7065L36.2783 218.388L41.7065 227.786Z",
    fill: "#026CE3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 218.097L74.6714 208.71L69.2536 199.312H58.4495L53.0317 208.71L58.4495 218.097H69.2536Z",
    fill: "#026CE3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 198.73L208.656 189.343L203.238 179.945H192.434L187.016 189.343L192.434 198.73H203.238Z",
    fill: "#026CE3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M320.469 150.887H309.676L304.248 160.284L309.676 169.682H320.469L325.898 160.284L320.469 150.887Z",
    fill: "#026CE3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M320.469 170.254H309.676L304.248 179.652L309.676 189.049H320.469L325.898 179.652L320.469 170.254Z",
    fill: "#026CE3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M320.469 227.786L325.898 218.388L320.469 208.99H309.676L304.248 218.388L309.676 227.786H320.469Z",
    fill: "#026CE3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M236.724 198.73L242.152 189.343L236.724 179.945H225.93L220.512 189.343L225.93 198.73H236.724Z",
    fill: "#026CE3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M337.212 159.994L342.641 150.607L337.212 141.209H326.419L321.001 150.607L326.419 159.994H337.212Z",
    fill: "#026CE3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M108.699 73.4141L103.271 82.8117L108.699 92.2094H119.493L124.921 82.8117L119.493 73.4141H108.699Z",
    fill: "#026CE3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M270.23 198.73L275.648 189.343L270.23 179.945H259.426L254.008 189.343L259.426 198.73H270.23Z",
    fill: "#026CE3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M303.716 218.097L309.144 208.71L303.716 199.312H292.923L287.505 208.71L292.923 218.097H303.716Z",
    fill: "#026CE3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M253.477 189.049L258.905 179.652L253.477 170.254H242.684L237.255 179.652L242.684 189.049H253.477Z",
    fill: "#026CE3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M286.973 208.418L292.402 199.021L286.973 189.623H276.18L270.751 199.021L276.18 208.418H286.973Z",
    fill: "#026CE3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M225.93 102.473L220.512 111.86L225.93 121.258H236.724L242.152 111.86L236.724 102.473H225.93Z",
    fill: "#026CE3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M353.966 131.518H343.172L337.744 140.915L343.172 150.313H353.966L359.394 140.915L353.966 131.518Z",
    fill: "#026CE3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5002 208.418L57.9284 199.021L52.5002 189.623H41.7065L36.2783 199.021L41.7065 208.418H52.5002Z",
    fill: "#026CE3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M387.461 130.946L389.545 127.278C389.43 123.35 389.451 119.485 389.389 115.557L387.419 112.15H376.667L371.239 121.527L376.667 130.904L387.461 130.946Z",
    fill: "#026CE3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M387.993 111.87L389.41 114.319C389.41 112.787 389.326 111.193 389.253 109.672L387.993 111.87Z",
    fill: "#026CE3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M389.608 128.404L387.993 131.259L389.993 134.728C389.806 132.582 389.691 130.488 389.608 128.404Z",
    fill: "#026CE3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M353.966 169.682L359.394 160.284L353.966 150.887H343.172L337.744 160.284L343.172 169.682H353.966Z",
    fill: "#026CE3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M337.212 199.312H326.419L321.001 208.71L326.419 218.097H337.212L342.641 208.71L337.212 199.312Z",
    fill: "#026CE3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9965 72.8422L89.2576 67.1953C84.2045 69.0186 79.589 70.8835 75.4111 72.8422H85.9965Z",
    fill: "#026CE3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M337.212 179.945H326.419L321.001 189.343L326.419 198.73H337.212L342.641 189.343L337.212 179.945Z",
    fill: "#026CE3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M337.212 160.576H326.419L321.001 169.974L326.419 179.361H337.212L342.641 169.974L337.212 160.576Z",
    fill: "#026CE3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M259.426 102.473L254.008 111.86L259.426 121.258H270.23L275.648 111.86L270.23 102.473H259.426Z",
    fill: "#026CE3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M292.923 83.1035L287.505 92.4908L292.923 101.888H303.716L309.144 92.4908L303.716 83.1035H292.923Z",
    fill: "#026CE3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M276.18 92.7812L270.751 102.179L276.18 111.577H286.973L292.402 102.179L286.973 92.7812H276.18Z",
    fill: "#026CE3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M337.212 256.844L342.641 247.446L337.212 238.049H326.419L321.001 247.446L326.419 256.844H337.212Z",
    fill: "#026CE3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M242.684 92.7812L237.255 102.179L242.684 111.577H253.477L258.905 102.179L253.477 92.7812H242.684Z",
    fill: "#026CE3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M359.914 63.7363L354.497 73.134L359.914 82.5212H370.718L376.136 73.134L370.718 63.7363H359.914Z",
    fill: "#026CE3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M343.172 73.4141L337.744 82.8117L343.172 92.2094H353.966L359.394 82.8117L353.966 73.4141H343.172Z",
    fill: "#026CE3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M309.676 92.7812L304.248 102.179L309.676 111.577H320.469L325.898 102.179L320.469 92.7812H309.676Z",
    fill: "#026CE3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M376.667 72.8397H379.73C378.064 68.4071 375.796 64.2248 372.99 60.4102L371.239 63.442L376.667 72.8397Z",
    fill: "#026CE3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M326.419 83.1035L321.001 92.4908L326.419 101.888H337.212L342.641 92.4908L337.212 83.1035H326.419Z",
    fill: "#026CE3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M337.212 218.682H326.419L321.001 228.079L326.419 237.467H337.212L342.641 228.079L337.212 218.682Z",
    fill: "#026CE3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M102.75 237.467L108.167 228.079L102.75 218.682H91.9455L86.5278 228.079L91.9455 237.467H102.75Z",
    fill: "#026CE3"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 247.155L91.425 237.757L85.9968 228.359H75.203L69.7749 237.757L75.203 247.155H85.9968Z",
    fill: "#026CE3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 237.467L74.6714 228.079L69.2536 218.682H58.4495L53.0317 228.079L58.4495 237.467H69.2536Z",
    fill: "#026CE3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M119.493 247.155L124.921 237.757L119.493 228.359H108.699L103.271 237.757L108.699 247.155H119.493Z",
    fill: "#026CE3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M136.246 237.467L141.664 228.079L136.246 218.682H125.442L120.024 228.079L125.442 237.467H136.246Z",
    fill: "#026CE3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9534 237.467H35.7576L41.1753 228.079L35.7576 218.682H24.9534L19.5356 228.079L24.9534 237.467Z",
    fill: "#026CE3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M152.989 227.786L158.417 218.388L152.989 208.99H142.195L136.767 218.388L142.195 227.786H152.989Z",
    fill: "#026CE3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9537 218.099H35.7579L41.1756 208.723L35.7579 199.346H26.3811C25.2454 200.388 24.141 201.429 23.0992 202.471L19.4839 208.723L24.9537 218.099Z",
    fill: "#026CE3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9534 256.844H35.7576L41.1753 247.446L35.7576 238.049H24.9534L19.5356 247.446L24.9534 256.844Z",
    fill: "#026CE3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5002 247.155L57.9284 237.757L52.5002 228.359H41.7065L36.2783 237.757L41.7065 247.155H52.5002Z",
    fill: "#026CE3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M253.477 208.418L258.905 199.021L253.477 189.623H242.684L237.255 199.021L242.684 208.418H253.477Z",
    fill: "#026CE3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M286.973 227.786L292.402 218.388L286.973 208.99H276.18L270.751 218.388L276.18 227.786H286.973Z",
    fill: "#026CE3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M320.469 247.155L325.898 237.757L320.469 228.359H309.676L304.248 237.757L309.676 247.155H320.469Z",
    fill: "#026CE3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M270.23 218.097L275.648 208.71L270.23 199.312H259.426L254.008 208.71L259.426 218.097H270.23Z",
    fill: "#026CE3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M303.716 237.467L309.144 228.079L303.716 218.682H292.923L287.505 228.079L292.923 237.467H303.716Z",
    fill: "#026CE3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M186.485 227.786L191.913 218.388L186.485 208.99H175.691L170.263 218.388L175.691 227.786H186.485Z",
    fill: "#026CE3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M236.724 218.097L242.152 208.71L236.724 199.312H225.93L220.512 208.71L225.93 218.097H236.724Z",
    fill: "#026CE3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M169.742 218.097L175.16 208.71L169.742 199.312H158.938L153.52 208.71L158.938 218.097H169.742Z",
    fill: "#026CE3"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 218.097L208.656 208.71L203.238 199.312H192.434L187.016 208.71L192.434 218.097H203.238Z",
    fill: "#026CE3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 208.418L225.409 199.021L219.981 189.623H209.187L203.759 199.021L209.187 208.418H219.981Z",
    fill: "#026CE3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M370.718 140.625L376.136 131.227L370.718 121.84H359.914L354.497 131.227L359.914 140.625H370.718Z",
    fill: "#026CE3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M102.75 159.994L108.167 150.607L102.75 141.209H91.9455L86.5278 150.607L91.9455 159.994H102.75Z",
    fill: "#026CE3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 169.682L91.425 160.284L85.9968 150.887H75.203L69.7749 160.284L75.203 169.682H85.9968Z",
    fill: "#026CE3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M152.989 169.682L158.417 160.284L152.989 150.887H142.195L136.767 160.284L142.195 169.682H152.989Z",
    fill: "#026CE3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M119.493 169.682L124.921 160.284L119.493 150.887H108.699L103.271 160.284L108.699 169.682H119.493Z",
    fill: "#026CE3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5405 112.15C42.6315 118.501 43.4522 124.98 45.916 130.904H52.5006L57.9287 121.527L52.5006 112.15H43.5405Z",
    fill: "#026CE3"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5003 131.518H46.1553C48.5203 137.196 51.8543 142.103 54.4902 146.927L57.9597 140.915L52.5003 131.518Z",
    fill: "#026CE3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4495 121.84L53.0317 131.227L58.4495 140.625H69.2536L74.6714 131.227L69.2536 121.84H58.4495Z",
    fill: "#026CE3"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M108.699 131.518L103.271 140.915L108.699 150.313H119.493L124.921 140.915L119.493 131.518H108.699Z",
    fill: "#026CE3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6714 150.605L69.2536 141.229H58.4494L54.7925 147.563C56.8762 151.616 58.5015 155.627 58.5224 160.066H69.2536L74.6714 150.605Z",
    fill: "#026CE3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 150.313L91.425 140.915L85.9968 131.518H75.203L69.7749 140.915L75.203 150.313H85.9968Z",
    fill: "#026CE3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M119.493 189.049L124.921 179.652L119.493 170.254H108.699L103.271 179.652L108.699 189.049H119.493Z",
    fill: "#026CE3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 189.049L91.425 179.652L85.9968 170.254H75.203L69.7749 179.652L75.203 189.049H85.9968Z",
    fill: "#026CE3"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9455 121.84L86.5278 131.227L91.9455 140.625H102.75L108.167 131.227L102.75 121.84H91.9455Z",
    fill: "#026CE3"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M158.938 141.209L153.52 150.607L158.938 159.994H169.742L175.16 150.607L169.742 141.209H158.938Z",
    fill: "#026CE3"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M136.246 179.361L141.664 169.974L136.246 160.576H125.442L120.024 169.974L125.442 179.361H136.246Z",
    fill: "#026CE3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M102.75 179.361L108.167 169.974L102.75 160.576H91.9455L86.5278 169.974L91.9455 179.361H102.75Z",
    fill: "#026CE3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M75.203 112.15L69.7749 121.548L75.203 130.946H85.9968L91.425 121.548L85.9968 112.15H75.203Z",
    fill: "#026CE3"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4495 102.473L53.0317 111.86L58.4495 121.258H69.2536L74.6714 111.86L69.2536 102.473H58.4495Z",
    fill: "#026CE3"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M50.292 92.7812C46.7707 98.4918 44.4982 104.883 43.624 111.535H52.5008L57.9289 102.158L52.5008 92.7812H50.292Z",
    fill: "#026CE3"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M69.254 179.363L74.6717 169.986L69.254 160.609H58.5123C58.2797 164.866 56.8773 168.976 54.4595 172.487L58.4498 179.394L69.254 179.363Z",
    fill: "#026CE3"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M136.246 159.994L141.664 150.607L136.246 141.209H125.442L120.024 150.607L125.442 159.994H136.246Z",
    fill: "#026CE3"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M321.001 34.3658L326.419 43.7426H337.212L342.641 34.3658L341.099 31.6882C337.358 29.4169 333.285 27.1664 328.825 24.9785H326.419L321.001 34.3658Z",
    fill: "#026CE3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M303.716 276.785H292.923L287.505 286.162L292.923 295.539H297.694C300.351 293.997 303.227 292.465 306.352 290.986L309.144 286.152L303.716 276.785Z",
    fill: "#026CE3"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M175.691 34.103H186.443L191.871 24.7262L190.986 23.2051C188.902 24.372 186.995 25.5493 185.276 26.737C181.744 29.1854 178.462 31.3942 175.253 33.4467L175.691 34.103Z",
    fill: "#026CE3"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M175.691 131.518L170.263 140.915L175.691 150.313H186.485L191.913 140.915L186.485 131.518H175.691Z",
    fill: "#026CE3"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M353.966 267.096H343.172L337.744 276.473L339.932 280.265C346.022 279.211 352.176 278.568 358.352 278.337L359.394 276.493L353.966 267.096Z",
    fill: "#026CE3"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M426.552 236.84C426.551 231.928 425.978 227.033 424.844 222.254L421.489 228.068L426.552 236.84Z",
    fill: "#026CE3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M236.734 315.521H225.93L220.491 324.898L221.231 326.159C227.616 327.567 234.178 328.003 240.693 327.451L242.162 324.898L236.734 315.521Z",
    fill: "#026CE3"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M257.53 7.72372C251.401 7.67474 245.275 7.98784 239.183 8.6614L242.704 14.7355H253.498L257.53 7.72372Z",
    fill: "#026CE3"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M320.469 267.096H309.676L304.248 276.473L309.676 285.849H318.896C319.553 285.62 320.199 285.381 320.865 285.162L325.898 276.452L320.469 267.096Z",
    fill: "#026CE3"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M242.684 34.1039H253.477L258.905 24.7063L253.477 15.3086H242.684L237.255 24.7063L242.684 34.1039Z",
    fill: "#026CE3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 53.474H152.989L158.417 44.0972L157.917 43.2324C152.781 45.7121 147.155 48.0875 140.497 50.5255L142.195 53.474Z",
    fill: "#026CE3"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4496 101.886H69.2538L74.6715 92.5096L69.2538 83.1328H58.8351L58.1266 83.7579L53.084 92.4992L58.4496 101.886Z",
    fill: "#026CE3"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 159.994L208.656 150.607L203.238 141.209H192.434L187.016 150.607L192.434 159.994H203.238Z",
    fill: "#026CE3"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M175.691 150.887L170.263 160.284L175.691 169.682H186.485L191.913 160.284L186.485 150.887H175.691Z",
    fill: "#026CE3"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9455 82.5173H102.75L108.167 73.1405L102.75 63.7637H99.4574C96.1998 64.8055 93.0916 65.8474 90.1327 66.8893L86.5278 73.1405L91.9455 82.5173Z",
    fill: "#026CE3"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1757 266.814L35.758 257.438H24.9538L19.9424 266.127C21.9033 269.872 24.4497 273.28 27.4855 276.222H35.758L41.1757 266.814Z",
    fill: "#026CE3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M119.493 267.096H108.699L103.271 276.473L108.605 285.714C111.089 285.56 113.58 285.613 116.055 285.87H119.493L124.921 276.493L119.493 267.096Z",
    fill: "#026CE3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1758 189.341L40.3423 187.893C35.7893 191.747 31.2051 195.123 27.0376 198.728H35.7164L41.1758 189.341Z",
    fill: "#026CE3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M108.699 72.841H119.493L124.921 63.4641L121.222 57.0566C117.669 58.1714 113.929 59.3383 109.762 60.5573C107.74 61.1616 105.782 61.7555 103.865 62.3493L103.219 63.4641L108.699 72.841Z",
    fill: "#026CE3"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4325 237.756L19.0044 228.379H12.1802C12.0775 231.013 12.1471 233.651 12.3885 236.276C12.7323 240.204 13.2116 243.819 13.8159 247.174H19.0252L24.4325 237.756Z",
    fill: "#026CE3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9284 276.496L52.5002 267.119H41.7065L36.2783 276.496L41.3731 285.31C41.8002 285.508 42.2378 285.706 42.6858 285.894H52.5002L57.9284 276.496Z",
    fill: "#026CE3"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M292.923 121.84L287.505 131.227L292.923 140.625H303.716L309.144 131.227L303.716 121.84H292.923Z",
    fill: "#026CE3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M259.426 141.209L254.008 150.607L259.426 159.994H270.23L275.648 150.607L270.23 141.209H259.426Z",
    fill: "#026CE3"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M276.18 131.518L270.751 140.915L276.18 150.313H286.973L292.402 140.915L286.973 131.518H276.18Z",
    fill: "#026CE3"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M209.187 131.518L203.759 140.915L209.187 150.313H219.981L225.409 140.915L219.981 131.518H209.187Z",
    fill: "#026CE3"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M242.684 131.518L237.255 140.915L242.684 150.313H253.477L258.905 140.915L253.477 131.518H242.684Z",
    fill: "#026CE3"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M225.93 141.209L220.512 150.607L225.93 159.994H236.724L242.152 150.607L236.724 141.209H225.93Z",
    fill: "#026CE3"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M303.716 198.73L309.144 189.343L303.716 179.945H292.923L287.505 189.343L292.923 198.73H303.716Z",
    fill: "#026CE3"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M286.973 189.049L292.402 179.652L286.973 170.254H276.18L270.751 179.652L276.18 189.049H286.973Z",
    fill: "#026CE3"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M303.716 160.576H292.923L287.505 169.974L292.923 179.361H303.716L309.144 169.974L303.716 160.576Z",
    fill: "#026CE3"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M303.716 141.209H292.923L287.505 150.607L292.923 159.994H303.716L309.144 150.607L303.716 141.209Z",
    fill: "#026CE3"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M320.469 150.313L325.898 140.915L320.469 131.518H309.676L304.248 140.915L309.676 150.313H320.469Z",
    fill: "#026CE3"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M108.699 92.7812L103.271 102.179L108.699 111.577H119.493L124.921 102.179L119.493 92.7812H108.699Z",
    fill: "#026CE3"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9455 83.1035L86.5278 92.4908L91.9455 101.888H102.75L108.167 92.4908L102.75 83.1035H91.9455Z",
    fill: "#026CE3"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M75.203 73.4141L69.7749 82.8117L75.203 92.2094H85.9968L91.425 82.8117L85.9968 73.4141H75.203Z",
    fill: "#026CE3"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2538 82.5194L74.6299 73.2051C69.2283 75.6852 64.1484 78.8129 59.502 82.5194H69.2538Z",
    fill: "#026CE3"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M158.938 121.84L153.52 131.227L158.938 140.625H169.742L175.16 131.227L169.742 121.84H158.938Z",
    fill: "#026CE3"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M125.442 102.473L120.024 111.86L125.442 121.258H136.246L141.664 111.86L136.246 102.473H125.442Z",
    fill: "#026CE3"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M192.434 121.84L187.016 131.227L192.434 140.625H203.238L208.656 131.227L203.238 121.84H192.434Z",
    fill: "#026CE3"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M175.691 112.15L170.263 121.548L175.691 130.946H186.485L191.913 121.548L186.485 112.15H175.691Z",
    fill: "#026CE3"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 112.15L136.767 121.548L142.195 130.946H152.989L158.417 121.548L152.989 112.15H142.195Z",
    fill: "#026CE3"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 198.73L74.6714 189.343L69.2536 179.945H58.4495L53.0317 189.343L58.4495 198.73H69.2536Z",
    fill: "#026CE3"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6665 92.2097H52.5002L56.6052 85.0938C54.3734 87.2433 52.3821 89.6294 50.6665 92.2097Z",
    fill: "#026CE3"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M119.493 208.418L124.921 199.021L119.493 189.623H108.699L103.271 199.021L108.699 208.418H119.493Z",
    fill: "#026CE3"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 131.518L136.767 140.915L142.195 150.313H152.989L158.417 140.915L152.989 131.518H142.195Z",
    fill: "#026CE3"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 208.418L91.425 199.021L85.9968 189.623H75.203L69.7749 199.021L75.203 208.418H85.9968Z",
    fill: "#026CE3"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M102.75 198.73L108.167 189.343L102.75 179.945H91.9455L86.5278 189.343L91.9455 198.73H102.75Z",
    fill: "#026CE3"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5003 189.052L57.9285 179.675L54.1256 173.018C53.9068 173.361 53.6776 173.705 53.4276 174.059C49.8069 179.061 45.5675 183.584 40.8105 187.52L41.7066 189.073L52.5003 189.052Z",
    fill: "#026CE3"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M108.699 112.15L103.271 121.548L108.699 130.946H119.493L124.921 121.548L119.493 112.15H108.699Z",
    fill: "#026CE3"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M125.442 121.84L120.024 131.227L125.442 140.625H136.246L141.664 131.227L136.246 121.84H125.442Z",
    fill: "#026CE3"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M75.203 92.7812L69.7749 102.179L75.203 111.577H85.9968L91.425 102.179L85.9968 92.7812H75.203Z",
    fill: "#026CE3"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9455 102.473L86.5278 111.86L91.9455 121.258H102.75L108.167 111.86L102.75 102.473H91.9455Z",
    fill: "#026CE3"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 169.682L225.409 160.284L219.981 150.887H209.187L203.759 160.284L209.187 169.682H219.981Z",
    fill: "#026CE3"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M253.477 169.682L258.905 160.284L253.477 150.887H242.684L237.255 160.284L242.684 169.682H253.477Z",
    fill: "#026CE3"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M236.724 179.361L242.152 169.974L236.724 160.576H225.93L220.512 169.974L225.93 179.361H236.724Z",
    fill: "#026CE3"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M270.23 179.361L275.648 169.974L270.23 160.576H259.426L254.008 169.974L259.426 179.361H270.23Z",
    fill: "#026CE3"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M286.973 169.682L292.402 160.284L286.973 150.887H276.18L270.751 160.284L276.18 169.682H286.973Z",
    fill: "#026CE3"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M152.989 189.049L158.417 179.652L152.989 170.254H142.195L136.767 179.652L142.195 189.049H152.989Z",
    fill: "#026CE3"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M136.246 198.73L141.664 189.343L136.246 179.945H125.442L120.024 189.343L125.442 198.73H136.246Z",
    fill: "#026CE3"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M169.742 179.361L175.16 169.974L169.742 160.576H158.938L153.52 169.974L158.938 179.361H169.742Z",
    fill: "#026CE3"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 179.361L208.656 169.974L203.238 160.576H192.434L187.016 169.974L192.434 179.361H203.238Z",
    fill: "#026CE3"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M186.485 189.049L191.913 179.652L186.485 170.254H175.691L170.263 179.652L175.691 189.049H186.485Z",
    fill: "#026CE3"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 189.049L225.409 179.652L219.981 170.254H209.187L203.759 179.652L209.187 189.049H219.981Z",
    fill: "#026CE3"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M343.172 34.1026H344.87C343.995 33.5191 343.099 32.9461 342.171 32.373L343.172 34.1026Z",
    fill: "#026CE3"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M309.676 34.6777L304.248 44.0754L309.676 53.4731H320.469L325.898 44.0754L320.469 34.6777H309.676Z",
    fill: "#026CE3"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M401.464 170.088C399.703 167.001 398.099 163.826 396.661 160.576H393.41L387.993 169.953L393.41 179.33H404.194L405.444 177.163C404.194 174.871 402.839 172.495 401.464 170.088Z",
    fill: "#026CE3"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M292.923 24.998L287.505 34.3957L292.923 43.783H303.716L309.144 34.3957L303.716 24.998H292.923Z",
    fill: "#026CE3"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M276.18 34.6777L270.751 44.0754L276.18 53.4731H286.973L292.402 44.0754L286.973 34.6777H276.18Z",
    fill: "#026CE3"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M404.204 198.73L409.632 189.343L404.204 179.945H393.41L387.993 189.343L393.41 198.73H404.204Z",
    fill: "#026CE3"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M387.461 208.99H376.667L371.239 218.388L376.667 227.786H387.461L392.889 218.388L387.461 208.99Z",
    fill: "#026CE3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M387.461 228.359H376.667L371.239 237.757L376.667 247.155H387.461L392.889 237.757L387.461 228.359Z",
    fill: "#026CE3"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M387.461 189.623H376.667L371.239 199.021L376.667 208.418H387.461L392.889 199.021L387.461 189.623Z",
    fill: "#026CE3"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M259.426 44.3672L254.008 53.7544L259.426 63.1521H270.23L275.648 53.7544L270.23 44.3672H259.426Z",
    fill: "#026CE3"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M186.485 305.258L191.913 295.861L186.485 286.463H175.691L170.263 295.861L175.691 305.258H186.485Z",
    fill: "#026CE3"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M242.684 34.6777L237.255 44.0754L242.684 53.4731H253.477L258.905 44.0754L253.477 34.6777H242.684Z",
    fill: "#026CE3"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M152.989 286.496H142.195L138.642 292.654C144.081 294.946 149.842 297.602 155.812 300.405L158.417 295.894L152.989 286.496Z",
    fill: "#026CE3"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M387.461 247.727H376.667L371.239 257.124L376.667 266.522H387.461L392.889 257.124L387.461 247.727Z",
    fill: "#026CE3"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 285.891L225.409 276.493L219.981 267.096H209.187L203.759 276.493L209.187 285.891H219.981Z",
    fill: "#026CE3"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 295.57L208.656 286.183L203.238 276.785H192.434L187.016 286.183L192.434 295.57H203.238Z",
    fill: "#026CE3"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M169.742 295.57L175.16 286.183L169.742 276.785H158.938L153.52 286.183L158.938 295.57H169.742Z",
    fill: "#026CE3"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M158.938 43.7409H169.773L175.191 34.3641L174.826 33.7285C169.561 37.1044 164.106 40.176 158.49 42.9282L158.938 43.7409Z",
    fill: "#026CE3"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M225.93 44.3672L220.512 53.7544L225.93 63.1521H236.724L242.152 53.7544L236.724 44.3672H225.93Z",
    fill: "#026CE3"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M209.187 34.6777L203.759 44.0754L209.187 53.4731H219.981L225.409 44.0754L219.981 34.6777H209.187Z",
    fill: "#026CE3"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M192.434 24.998L187.016 34.3957L192.434 43.783H203.238L208.656 34.3957L203.238 24.998H192.434Z",
    fill: "#026CE3"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M376.667 267.096L371.239 276.473L372.281 278.192C379.574 278.296 386.148 278.504 392.077 277.931L392.921 276.473L387.492 267.096H376.667Z",
    fill: "#026CE3"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2578 290.382L85.997 286.496H75.2032L71.4004 293.091C77.1255 293.061 82.8116 292.148 88.2578 290.382Z",
    fill: "#026CE3"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M102.75 276.785H91.9455L86.5278 286.162L88.8512 290.184C94.967 288.371 100.895 286.297 107.938 285.756L102.75 276.785Z",
    fill: "#026CE3"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M152.989 285.891L158.417 276.493L152.989 267.096H142.195L136.767 276.493L142.195 285.891H152.989Z",
    fill: "#026CE3"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M136.246 276.785H125.442L120.024 286.162L120.212 286.485C123.61 287.132 126.948 288.059 130.193 289.256C132.725 290.184 135.402 291.236 138.08 292.382L141.664 286.131L136.246 276.785Z",
    fill: "#026CE3"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 276.785H58.4495L53.0317 286.162L55.3968 290.257C56.7408 290.642 58.0952 291.017 59.5643 291.382C63.223 292.352 66.9808 292.901 70.7644 293.017L74.7235 286.162L69.2536 276.785Z",
    fill: "#026CE3"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M192.434 44.3672L187.016 53.7544L192.434 63.1521H203.238L208.656 53.7544L203.238 44.3672H192.434Z",
    fill: "#026CE3"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M175.691 34.6777L170.263 44.0754L175.691 53.4731H186.485L191.913 44.0754L186.485 34.6777H175.691Z",
    fill: "#026CE3"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M209.187 54.0449L203.759 63.4426L209.187 72.8402H219.981L225.409 63.4426L219.981 54.0449H209.187Z",
    fill: "#026CE3"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M169.742 276.203L175.16 266.816L169.742 257.418H158.938L153.52 266.816L158.938 276.203H169.742Z",
    fill: "#026CE3"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M158.938 44.3672L153.52 53.7544L158.938 63.1521H169.742L175.16 53.7544L169.742 44.3672H158.938Z",
    fill: "#026CE3"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M309.676 286.494L307.3 290.578C310.353 289.161 313.645 287.786 317.24 286.463L309.676 286.494Z",
    fill: "#026CE3"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M270.23 276.203L275.648 266.816L270.23 257.418H259.426L254.008 266.816L259.426 276.203H270.23Z",
    fill: "#026CE3"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M286.973 285.891L292.402 276.493L286.973 267.096H276.18L270.751 276.493L276.18 285.891H286.973Z",
    fill: "#026CE3"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M186.485 285.891L191.913 276.493L186.485 267.096H175.691L170.263 276.493L175.691 285.891H186.485Z",
    fill: "#026CE3"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M392.786 277.868C394.89 277.66 396.979 277.312 399.037 276.826H393.4L392.786 277.868Z",
    fill: "#026CE3"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M236.724 295.57L242.152 286.183L236.724 276.785H225.93L220.512 286.183L225.93 295.57H236.724Z",
    fill: "#026CE3"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 276.203L208.656 266.816L203.238 257.418H192.434L187.016 266.816L192.434 276.203H203.238Z",
    fill: "#026CE3"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 266.522L225.409 257.124L219.981 247.727H209.187L203.759 257.124L209.187 266.522H219.981Z",
    fill: "#026CE3"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M253.477 266.522L258.905 257.124L253.477 247.727H242.684L237.255 257.124L242.684 266.522H253.477Z",
    fill: "#026CE3"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M236.724 276.203L242.152 266.816L236.724 257.418H225.93L220.512 266.816L225.93 276.203H236.724Z",
    fill: "#026CE3"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5005 286.496H44.0718C47.5084 287.871 51.0137 289.067 54.5738 290.08L52.5005 286.496Z",
    fill: "#026CE3"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M270.23 314.95L275.648 305.552L270.23 296.154H259.426L254.008 305.552L259.426 314.95H270.23Z",
    fill: "#026CE3"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M253.477 305.258L258.905 295.861L253.477 286.463H242.684L237.255 295.861L242.684 305.258H253.477Z",
    fill: "#026CE3"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M276.18 305.844L270.918 314.95C274.784 312.126 278.555 309.032 282.692 305.844H276.18Z",
    fill: "#026CE3"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M236.724 314.95L242.152 305.552L236.724 296.154H225.93L220.512 305.552L225.93 314.95H236.724Z",
    fill: "#026CE3"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M270.126 315.521H259.426L254.446 324.148C260.043 322.003 265.319 319.1 270.126 315.521Z",
    fill: "#026CE3"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M420.979 247.727H410.164L404.736 257.103L410.164 266.48H415.488C416.092 265.761 416.686 265.011 417.28 264.209C419.965 260.6 422.132 256.634 423.719 252.425L420.979 247.727Z",
    fill: "#026CE3"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 315.521H192.434L191.747 316.72C196.956 318.866 202.165 320.814 207.239 322.471L203.238 315.521Z",
    fill: "#026CE3"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M191.913 315.232L186.485 305.855H175.691L173.941 308.887C179.65 311.534 185.401 314.097 191.194 316.503L191.913 315.232Z",
    fill: "#026CE3"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 296.154H192.434L187.016 305.552L192.434 314.95H203.238L208.656 305.552L203.238 296.154Z",
    fill: "#026CE3"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M169.773 296.154H158.938L156.354 300.624C161.897 303.229 167.606 305.958 173.378 308.636L175.16 305.51L169.773 296.154Z",
    fill: "#026CE3"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 305.258L225.409 295.861L219.981 286.463H209.187L203.759 295.861L209.187 305.258H219.981Z",
    fill: "#026CE3"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M421.489 247.448L423.979 251.772C425.453 247.586 426.299 243.204 426.49 238.77L421.489 247.448Z",
    fill: "#026CE3"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 325.203H216.761C218.011 325.516 219.241 325.797 220.47 326.057L219.981 325.203Z",
    fill: "#026CE3"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M253.123 324.63L253.613 324.453L258.937 315.232L253.509 305.855H242.704L237.276 315.232L242.704 324.609L253.123 324.63Z",
    fill: "#026CE3"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M420.979 228.359H410.164L404.736 237.757L410.164 247.155H420.979L426.407 237.757L420.979 228.359Z",
    fill: "#026CE3"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M242.705 325.203L241.444 327.401C242.277 327.297 243.111 327.183 243.934 327.037C246.438 326.576 248.912 325.963 251.342 325.203H242.705Z",
    fill: "#026CE3"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M420.76 208.99H410.164L404.736 218.367L410.164 227.744H420.979L424.646 221.409C423.606 217.194 422.308 213.046 420.76 208.99Z",
    fill: "#026CE3"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M254.008 15.0157L259.426 24.3926H270.23L275.648 15.0157L271.876 8.49364C267.23 8.03521 262.666 7.77475 258.217 7.72266L254.008 15.0157Z",
    fill: "#026CE3"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M220.512 15.0149L225.93 24.3917H236.734L242.152 15.0149L238.526 8.76367C233.161 9.36597 227.833 10.2598 222.565 11.4413L220.512 15.0149Z",
    fill: "#026CE3"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 324.631L225.409 315.254L219.981 305.877H209.187L203.759 315.254L208.093 322.766C210.26 323.453 212.406 324.089 214.532 324.651L219.981 324.631Z",
    fill: "#026CE3"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M209.187 15.3086L203.759 24.7063L209.187 34.1039H219.981L225.409 24.7063L219.981 15.3086H209.187Z",
    fill: "#026CE3"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M404.204 218.682H393.41L387.993 228.079L393.41 237.467H404.204L409.632 228.079L404.204 218.682Z",
    fill: "#026CE3"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M404.204 238.049H393.41L387.993 247.446L393.41 256.844H404.204L409.632 247.446L404.204 238.049Z",
    fill: "#026CE3"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M393.41 257.419L387.993 266.795L393.41 276.172H401.068C402.447 275.746 403.794 275.224 405.1 274.609L409.611 266.785L404.194 257.408L393.41 257.419Z",
    fill: "#026CE3"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M420.541 208.418C418.047 202.023 415.219 195.763 412.071 189.664H410.164L404.736 199.041L410.164 208.418H420.541Z",
    fill: "#026CE3"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M404.204 199.312H393.41L387.993 208.71L393.41 218.097H404.204L409.632 208.71L404.204 199.312Z",
    fill: "#026CE3"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M410.164 267.096L406.09 274.149C409.467 272.373 412.481 269.981 414.977 267.096H410.164Z",
    fill: "#026CE3"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M270.23 295.57L275.648 286.183L270.23 276.785H259.426L254.008 286.183L259.426 295.57H270.23Z",
    fill: "#026CE3"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M283.441 305.25C285.379 303.77 287.411 302.27 289.557 300.77L292.402 295.873L286.973 286.496H276.18L270.751 295.873L276.18 305.25H283.441Z",
    fill: "#026CE3"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M404.736 179.652L410.164 189.029H411.779C409.924 185.382 407.931 181.635 405.799 177.787L404.736 179.652Z",
    fill: "#026CE3"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M292.922 296.154L290.703 300.04C292.599 298.749 294.6 297.467 296.736 296.196L292.922 296.154Z",
    fill: "#026CE3"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M192.434 24.4132H203.238L208.374 15.5156C202.567 17.4894 196.941 19.9608 191.559 22.9025L192.434 24.4132Z",
    fill: "#026CE3"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M225.93 24.998L220.512 34.3957L225.93 43.783H236.724L242.152 34.3957L236.724 24.998H225.93Z",
    fill: "#026CE3"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M259.426 24.998L254.008 34.3957L259.426 43.783H270.23L275.648 34.3957L270.23 24.998H259.426Z",
    fill: "#026CE3"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M253.477 285.891L258.905 276.493L253.477 267.096H242.684L237.255 276.493L242.684 285.891H253.477Z",
    fill: "#026CE3"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M210.688 14.735H219.981L221.763 11.6094C217.877 12.5575 214.178 13.5993 210.688 14.735Z",
    fill: "#026CE3"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M287.505 15.0183L292.923 24.3951H303.716L308.342 16.4769C302.23 14.3743 296 12.6348 289.682 11.2676L287.505 15.0183Z",
    fill: "#026CE3"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M309.676 34.1024H320.469L325.898 24.7255L325.012 23.1836C321.539 21.5652 317.813 19.9954 313.833 18.4743C312.176 17.8388 310.53 17.2449 308.884 16.6719L304.248 24.7047L309.676 34.1024Z",
    fill: "#026CE3"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M326.418 24.4149H327.637L325.96 23.623L326.418 24.4149Z",
    fill: "#026CE3"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M276.18 14.7362H286.973L289.057 11.1522C283.633 10.0025 278.152 9.13998 272.637 8.56836L276.18 14.7362Z",
    fill: "#026CE3"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M276.18 34.1039H286.973L292.402 24.7063L286.973 15.3086H276.18L270.751 24.7063L276.18 34.1039Z",
    fill: "#026CE3"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M276.18 54.0449L270.751 63.4426L276.18 72.8402H286.973L292.402 63.4426L286.973 54.0449H276.18Z",
    fill: "#026CE3"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M337.212 276.203L342.641 266.816L337.212 257.418H326.419L321.001 266.816L326.419 276.203H337.212Z",
    fill: "#026CE3"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M353.966 189.623H343.172L337.744 199.021L343.172 208.418H353.966L359.394 199.021L353.966 189.623Z",
    fill: "#026CE3"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M320.469 266.522L325.898 257.124L320.469 247.727H309.676L304.248 257.124L309.676 266.522H320.469Z",
    fill: "#026CE3"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M353.966 208.99H343.172L337.744 218.388L343.172 227.786H353.966L359.394 218.388L353.966 208.99Z",
    fill: "#026CE3"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M353.966 228.359H343.172L337.744 237.757L343.172 247.155H353.966L359.394 237.757L353.966 228.359Z",
    fill: "#026CE3"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M353.966 266.522L359.394 257.124L353.966 247.727H343.172L337.744 257.124L343.172 266.522H353.966Z",
    fill: "#026CE3"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M270.23 237.467L275.648 228.079L270.23 218.682H259.426L254.008 228.079L259.426 237.467H270.23Z",
    fill: "#026CE3"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M253.477 227.786L258.905 218.388L253.477 208.99H242.684L237.255 218.388L242.684 227.786H253.477Z",
    fill: "#026CE3"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M303.716 256.844L309.144 247.446L303.716 238.049H292.923L287.505 247.446L292.923 256.844H303.716Z",
    fill: "#026CE3"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M286.973 247.155L292.402 237.757L286.973 228.359H276.18L270.751 237.757L276.18 247.155H286.973Z",
    fill: "#026CE3"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M359.914 63.1513H370.708L372.604 59.8694C368.744 54.545 364.318 49.6545 359.404 45.2832L354.497 53.7849L359.914 63.1513Z",
    fill: "#026CE3"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M309.676 73.4141L304.248 82.8117L309.676 92.2094H320.469L325.898 82.8117L320.469 73.4141H309.676Z",
    fill: "#026CE3"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M343.172 54.0449L337.744 63.4426L343.172 72.8402H353.966L359.394 63.4426L353.966 54.0449H343.172Z",
    fill: "#026CE3"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M326.419 63.7363L321.001 73.134L326.419 82.5212H337.212L342.641 73.134L337.212 63.7363H326.419Z",
    fill: "#026CE3"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M292.923 63.7363L287.505 73.134L292.923 82.5212H303.716L309.144 73.134L303.716 63.7363H292.923Z",
    fill: "#026CE3"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M236.724 237.467L242.152 228.079L236.724 218.682H225.93L220.512 228.079L225.93 237.467H236.724Z",
    fill: "#026CE3"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M353.966 170.254H343.172L337.744 179.652L343.172 189.049H353.966L359.394 179.652L353.966 170.254Z",
    fill: "#026CE3"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M370.718 179.361L376.136 169.974L370.718 160.576H359.914L354.497 169.974L359.914 179.361H370.718Z",
    fill: "#026CE3"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M370.718 141.209H359.914L354.497 150.607L359.914 159.994H370.718L376.136 150.607L370.718 141.209Z",
    fill: "#026CE3"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M387.461 150.313L391.264 143.728C390.743 141.134 390.399 138.623 390.139 136.154L387.461 131.518H376.667L371.239 140.894L376.667 150.271L387.461 150.313Z",
    fill: "#026CE3"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M175.691 73.4141L170.263 82.8117L175.691 92.2094H186.485L191.913 82.8117L186.485 73.4141H175.691Z",
    fill: "#026CE3"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0045 208.419L21.2967 204.449C20.1922 205.709 19.1658 207.034 18.2231 208.419H19.0045Z",
    fill: "#026CE3"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M102.75 63.1505L103.073 62.5879L101.281 63.1505H102.75Z",
    fill: "#026CE3"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4324 257.125L19.0042 247.748H13.9199C14.9483 253.896 16.8645 259.863 19.6085 265.46L24.4324 257.125Z",
    fill: "#026CE3"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0046 227.789L24.4327 218.412L19.0046 209.035H17.8585C14.3159 214.662 12.3611 221.142 12.2012 227.789H19.0046Z",
    fill: "#026CE3"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M125.442 63.7363L120.024 73.134L125.442 82.5212H136.246L141.664 73.134L136.246 63.7363H125.442Z",
    fill: "#026CE3"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 73.4141L136.767 82.8117L142.195 92.2094H152.989L158.417 82.8117L152.989 73.4141H142.195Z",
    fill: "#026CE3"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5002 266.522L57.9284 257.124L52.5002 247.727H41.7065L36.2783 257.124L41.7065 266.522H52.5002Z",
    fill: "#026CE3"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M192.434 83.1035L187.016 92.4908L192.434 101.888H203.238L208.656 92.4908L203.238 83.1035H192.434Z",
    fill: "#026CE3"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M276.18 73.4141L270.751 82.8117L276.18 92.2094H286.973L292.402 82.8117L286.973 73.4141H276.18Z",
    fill: "#026CE3"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M158.938 83.1035L153.52 92.4908L158.938 101.888H169.742L175.16 92.4908L169.742 83.1035H158.938Z",
    fill: "#026CE3"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M169.742 237.467L175.16 228.079L169.742 218.682H158.938L153.52 228.079L158.938 237.467H169.742Z",
    fill: "#026CE3"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 256.844L74.6714 247.446L69.2536 238.049H58.4495L53.0317 247.446L58.4495 256.844H69.2536Z",
    fill: "#026CE3"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M152.989 247.155L158.417 237.757L152.989 228.359H142.195L136.767 237.757L142.195 247.155H152.989Z",
    fill: "#026CE3"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M225.93 63.7363L220.512 73.134L225.93 82.5212H236.724L242.152 73.134L236.724 63.7363H225.93Z",
    fill: "#026CE3"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 237.467L208.656 228.079L203.238 218.682H192.434L187.016 228.079L192.434 237.467H203.238Z",
    fill: "#026CE3"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 227.786L225.409 218.388L219.981 208.99H209.187L203.759 218.388L209.187 227.786H219.981Z",
    fill: "#026CE3"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 266.522L91.425 257.124L85.9968 247.727H75.203L69.7749 257.124L75.203 266.522H85.9968Z",
    fill: "#026CE3"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M102.75 256.844L108.167 247.446L102.75 238.049H91.9455L86.5278 247.446L91.9455 256.844H102.75Z",
    fill: "#026CE3"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M119.493 266.522L124.921 257.124L119.493 247.727H108.699L103.271 257.124L108.699 266.522H119.493Z",
    fill: "#026CE3"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M136.246 256.844L141.664 247.446L136.246 238.049H125.442L120.024 247.446L125.442 256.844H136.246Z",
    fill: "#026CE3"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M186.485 247.155L191.913 237.757L186.485 228.359H175.691L170.263 237.757L175.691 247.155H186.485Z",
    fill: "#026CE3"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M370.718 238.049H359.914L354.497 247.446L359.914 256.844H370.718L376.136 247.446L370.718 238.049Z",
    fill: "#026CE3"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M370.718 218.682H359.914L354.497 228.079L359.914 237.467H370.718L376.136 228.079L370.718 218.682Z",
    fill: "#026CE3"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M370.718 199.312H359.914L354.497 208.71L359.914 218.097H370.718L376.136 208.71L370.718 199.312Z",
    fill: "#026CE3"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M370.718 257.418H359.914L354.497 266.816L359.914 276.203H370.718L376.136 266.816L370.718 257.418Z",
    fill: "#026CE3"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M370.718 179.945H359.914L354.497 189.343L359.914 198.73H370.718L376.136 189.343L370.718 179.945Z",
    fill: "#026CE3"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M286.973 266.522L292.402 257.124L286.973 247.727H276.18L270.751 257.124L276.18 266.522H286.973Z",
    fill: "#026CE3"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M303.716 276.203L309.144 266.816L303.716 257.418H292.923L287.505 266.816L292.923 276.203H303.716Z",
    fill: "#026CE3"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M387.461 189.049L392.889 179.652L387.461 170.254H376.667L371.239 179.652L376.667 189.049H387.461Z",
    fill: "#026CE3"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M371.531 278.161L370.708 276.744H359.914L359.039 278.276C363.425 278.161 367.593 278.161 371.531 278.161Z",
    fill: "#026CE3"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M339.306 280.4L337.223 276.785H326.419L321.72 284.922C322.907 284.526 324.116 284.141 325.356 283.766C329.939 282.381 334.596 281.257 339.306 280.4Z",
    fill: "#026CE3"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M337.744 44.0748L343.172 53.4516H353.966L358.946 44.8145C354.787 41.1255 350.376 37.7312 345.745 34.6562H343.172L337.744 44.0748Z",
    fill: "#026CE3"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M259.426 83.1035L254.008 92.4908L259.426 101.888H270.23L275.648 92.4908L270.23 83.1035H259.426Z",
    fill: "#026CE3"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M209.187 92.7812L203.759 102.179L209.187 111.577H219.981L225.409 102.179L219.981 92.7812H209.187Z",
    fill: "#026CE3"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M242.684 54.0449L237.255 63.4426L242.684 72.8402H253.477L258.905 63.4426L253.477 54.0449H242.684Z",
    fill: "#026CE3"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M292.923 44.3672L287.505 53.7544L292.923 63.1521H303.716L309.144 53.7544L303.716 44.3672H292.923Z",
    fill: "#026CE3"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M326.419 44.3672L321.001 53.7544L326.419 63.1521H337.212L342.641 53.7544L337.212 44.3672H326.419Z",
    fill: "#026CE3"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M309.676 54.0449L304.248 63.4426L309.676 72.8402H320.469L325.898 63.4426L320.469 54.0449H309.676Z",
    fill: "#026CE3"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M396.401 159.99C394.232 155.042 392.574 149.886 391.452 144.602L387.993 150.603L393.41 159.98L396.401 159.99Z",
    fill: "#026CE3"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M270.23 256.844L275.648 247.446L270.23 238.049H259.426L254.008 247.446L259.426 256.844H270.23Z",
    fill: "#026CE3"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M387.461 150.887H376.667L371.239 160.284L376.667 169.682H387.461L392.889 160.284L387.461 150.887Z",
    fill: "#026CE3"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M259.426 63.7363L254.008 73.134L259.426 82.5212H270.23L275.648 73.134L270.23 63.7363H259.426Z",
    fill: "#026CE3"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M253.477 247.155L258.905 237.757L253.477 228.359H242.684L237.255 237.757L242.684 247.155H253.477Z",
    fill: "#026CE3"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M158.938 63.7363L153.52 73.134L158.938 82.5212H169.742L175.16 73.134L169.742 63.7363H158.938Z",
    fill: "#026CE3"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M121.848 56.8462L125.484 63.0975H136.288L141.706 53.7206L139.966 50.6992C134.631 52.6788 128.682 54.6792 121.848 56.8462Z",
    fill: "#026CE3"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M175.691 54.0449L170.263 63.4426L175.691 72.8402H186.485L191.913 63.4426L186.485 54.0449H175.691Z",
    fill: "#026CE3"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7577 276.785H28.0791C31.7401 280.105 35.8946 282.836 40.394 284.881L35.7577 276.785Z",
    fill: "#026CE3"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 276.203L74.6714 266.816L69.2536 257.418H58.4495L53.0317 266.816L58.4495 276.203H69.2536Z",
    fill: "#026CE3"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M242.684 73.4141L237.255 82.8117L242.684 92.2094H253.477L258.905 82.8117L253.477 73.4141H242.684Z",
    fill: "#026CE3"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M192.434 63.7363L187.016 73.134L192.434 82.5212H203.238L208.656 73.134L203.238 63.7363H192.434Z",
    fill: "#026CE3"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M225.93 83.1035L220.512 92.4908L225.93 101.888H236.724L242.152 92.4908L236.724 83.1035H225.93Z",
    fill: "#026CE3"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M209.187 73.4141L203.759 82.8117L209.187 92.2094H219.981L225.409 82.8117L219.981 73.4141H209.187Z",
    fill: "#026CE3"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 54.0449L136.767 63.4426L142.195 72.8402H152.989L158.417 63.4426L152.989 54.0449H142.195Z",
    fill: "#026CE3"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 256.844L208.656 247.446L203.238 238.049H192.434L187.016 247.446L192.434 256.844H203.238Z",
    fill: "#026CE3"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 247.155L225.409 237.757L219.981 228.359H209.187L203.759 237.757L209.187 247.155H219.981Z",
    fill: "#026CE3"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M236.724 256.844L242.152 247.446L236.724 238.049H225.93L220.512 247.446L225.93 256.844H236.724Z",
    fill: "#026CE3"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 285.891L91.425 276.493L85.9968 267.096H75.203L69.7749 276.493L75.203 285.891H85.9968Z",
    fill: "#026CE3"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M186.485 266.522L191.913 257.124L186.485 247.727H175.691L170.263 257.124L175.691 266.522H186.485Z",
    fill: "#026CE3"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M169.742 256.844L175.16 247.446L169.742 238.049H158.938L153.52 247.446L158.938 256.844H169.742Z",
    fill: "#026CE3"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M102.75 276.203L108.167 266.816L102.75 257.418H91.9455L86.5278 266.816L91.9455 276.203H102.75Z",
    fill: "#026CE3"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M136.246 276.203L141.664 266.816L136.246 257.418H125.442L120.024 266.816L125.442 276.203H136.246Z",
    fill: "#026CE3"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M152.989 266.522L158.417 257.124L152.989 247.727H142.195L136.767 257.124L142.195 266.522H152.989Z",
    fill: "#026CE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.172 92.7812L337.744 102.179L343.172 111.577H353.966L359.394 102.179L353.966 92.7812H343.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.419 102.473L321.001 111.86L326.419 121.258H337.212L342.641 111.86L337.212 102.473H326.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.676 112.15L304.248 121.548L309.676 130.946H320.469L325.898 121.548L320.469 112.15H309.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.923 102.473L287.505 111.86L292.923 121.258H303.716L309.144 111.86L303.716 102.473H292.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.718 121.258L376.136 111.86L370.718 102.473H359.914L354.497 111.86L359.914 121.258H370.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.461 111.577L389.201 108.566C388.934 103.25 388.199 97.9677 387.003 92.7812H376.667L371.239 102.158L376.667 111.535L387.461 111.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.966 130.946L359.394 121.548L353.966 112.15H343.172L337.744 121.548L343.172 130.946H353.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.914 83.1035L354.497 92.4908L359.914 101.888H370.718L376.136 92.4908L370.718 83.1035H359.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.239 82.8104L376.667 92.1872H386.867C385.26 85.703 382.947 79.4143 379.97 73.4336H376.667L371.239 82.8104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.938 102.473L153.52 111.86L158.938 121.258H169.742L175.16 111.86L169.742 102.473H158.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.212 121.84H326.419L321.001 131.227L326.419 140.625H337.212L342.641 131.227L337.212 121.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.434 102.473L187.016 111.86L192.434 121.258H203.238L208.656 111.86L203.238 102.473H192.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.691 92.7812L170.263 102.179L175.691 111.577H186.485L191.913 102.179L186.485 92.7812H175.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.442 83.1035L120.024 92.4908L125.442 101.888H136.246L141.664 92.4908L136.246 83.1035H125.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.195 92.7812L136.767 102.179L142.195 111.577H152.989L158.417 102.179L152.989 92.7812H142.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93 121.84L220.512 131.227L225.93 140.625H236.724L242.152 131.227L236.724 121.84H225.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.684 112.15L237.255 121.548L242.684 130.946H253.477L258.905 121.548L253.477 112.15H242.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.426 121.84L254.008 131.227L259.426 140.625H270.23L275.648 131.227L270.23 121.84H259.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18 112.15L270.751 121.548L276.18 130.946H286.973L292.402 121.548L286.973 112.15H276.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.187 112.15L203.759 121.548L209.187 130.946H219.981L225.409 121.548L219.981 112.15H209.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.469 189.623H309.676L304.248 199.021L309.676 208.418H320.469L325.898 199.021L320.469 189.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.493 227.786L124.921 218.388L119.493 208.99H108.699L103.271 218.388L108.699 227.786H119.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.246 218.097L141.664 208.71L136.246 199.312H125.442L120.024 208.71L125.442 218.097H136.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.989 208.418L158.417 199.021L152.989 189.623H142.195L136.767 199.021L142.195 208.418H152.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.742 198.73L175.16 189.343L169.742 179.945H158.938L153.52 189.343L158.938 198.73H169.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.485 208.418L191.913 199.021L186.485 189.623H175.691L170.263 199.021L175.691 208.418H186.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 227.786L91.425 218.388L85.9968 208.99H75.203L69.7749 218.388L75.203 227.786H85.9968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75 218.097L108.167 208.71L102.75 199.312H91.9455L86.5278 208.71L91.9455 218.097H102.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7065 227.786H52.5002L57.9284 218.388L52.5002 208.99H41.7065L36.2783 218.388L41.7065 227.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 218.097L74.6714 208.71L69.2536 199.312H58.4495L53.0317 208.71L58.4495 218.097H69.2536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.238 198.73L208.656 189.343L203.238 179.945H192.434L187.016 189.343L192.434 198.73H203.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.469 150.887H309.676L304.248 160.284L309.676 169.682H320.469L325.898 160.284L320.469 150.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.469 170.254H309.676L304.248 179.652L309.676 189.049H320.469L325.898 179.652L320.469 170.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.469 227.786L325.898 218.388L320.469 208.99H309.676L304.248 218.388L309.676 227.786H320.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.724 198.73L242.152 189.343L236.724 179.945H225.93L220.512 189.343L225.93 198.73H236.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.212 159.994L342.641 150.607L337.212 141.209H326.419L321.001 150.607L326.419 159.994H337.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.699 73.4141L103.271 82.8117L108.699 92.2094H119.493L124.921 82.8117L119.493 73.4141H108.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23 198.73L275.648 189.343L270.23 179.945H259.426L254.008 189.343L259.426 198.73H270.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.716 218.097L309.144 208.71L303.716 199.312H292.923L287.505 208.71L292.923 218.097H303.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.477 189.049L258.905 179.652L253.477 170.254H242.684L237.255 179.652L242.684 189.049H253.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.973 208.418L292.402 199.021L286.973 189.623H276.18L270.751 199.021L276.18 208.418H286.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93 102.473L220.512 111.86L225.93 121.258H236.724L242.152 111.86L236.724 102.473H225.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.966 131.518H343.172L337.744 140.915L343.172 150.313H353.966L359.394 140.915L353.966 131.518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5002 208.418L57.9284 199.021L52.5002 189.623H41.7065L36.2783 199.021L41.7065 208.418H52.5002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.461 130.946L389.545 127.278C389.43 123.35 389.451 119.485 389.389 115.557L387.419 112.15H376.667L371.239 121.527L376.667 130.904L387.461 130.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.993 111.87L389.41 114.319C389.41 112.787 389.326 111.193 389.253 109.672L387.993 111.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.608 128.404L387.993 131.259L389.993 134.728C389.806 132.582 389.691 130.488 389.608 128.404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.966 169.682L359.394 160.284L353.966 150.887H343.172L337.744 160.284L343.172 169.682H353.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.212 199.312H326.419L321.001 208.71L326.419 218.097H337.212L342.641 208.71L337.212 199.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9965 72.8422L89.2576 67.1953C84.2045 69.0186 79.589 70.8835 75.4111 72.8422H85.9965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.212 179.945H326.419L321.001 189.343L326.419 198.73H337.212L342.641 189.343L337.212 179.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.212 160.576H326.419L321.001 169.974L326.419 179.361H337.212L342.641 169.974L337.212 160.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.426 102.473L254.008 111.86L259.426 121.258H270.23L275.648 111.86L270.23 102.473H259.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.923 83.1035L287.505 92.4908L292.923 101.888H303.716L309.144 92.4908L303.716 83.1035H292.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18 92.7812L270.751 102.179L276.18 111.577H286.973L292.402 102.179L286.973 92.7812H276.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.212 256.844L342.641 247.446L337.212 238.049H326.419L321.001 247.446L326.419 256.844H337.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.684 92.7812L237.255 102.179L242.684 111.577H253.477L258.905 102.179L253.477 92.7812H242.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.914 63.7363L354.497 73.134L359.914 82.5212H370.718L376.136 73.134L370.718 63.7363H359.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.172 73.4141L337.744 82.8117L343.172 92.2094H353.966L359.394 82.8117L353.966 73.4141H343.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.676 92.7812L304.248 102.179L309.676 111.577H320.469L325.898 102.179L320.469 92.7812H309.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.667 72.8397H379.73C378.064 68.4071 375.796 64.2248 372.99 60.4102L371.239 63.442L376.667 72.8397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.419 83.1035L321.001 92.4908L326.419 101.888H337.212L342.641 92.4908L337.212 83.1035H326.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.212 218.682H326.419L321.001 228.079L326.419 237.467H337.212L342.641 228.079L337.212 218.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75 237.467L108.167 228.079L102.75 218.682H91.9455L86.5278 228.079L91.9455 237.467H102.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 247.155L91.425 237.757L85.9968 228.359H75.203L69.7749 237.757L75.203 247.155H85.9968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 237.467L74.6714 228.079L69.2536 218.682H58.4495L53.0317 228.079L58.4495 237.467H69.2536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.493 247.155L124.921 237.757L119.493 228.359H108.699L103.271 237.757L108.699 247.155H119.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.246 237.467L141.664 228.079L136.246 218.682H125.442L120.024 228.079L125.442 237.467H136.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9534 237.467H35.7576L41.1753 228.079L35.7576 218.682H24.9534L19.5356 228.079L24.9534 237.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.989 227.786L158.417 218.388L152.989 208.99H142.195L136.767 218.388L142.195 227.786H152.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9537 218.099H35.7579L41.1756 208.723L35.7579 199.346H26.3811C25.2454 200.388 24.141 201.429 23.0992 202.471L19.4839 208.723L24.9537 218.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9534 256.844H35.7576L41.1753 247.446L35.7576 238.049H24.9534L19.5356 247.446L24.9534 256.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5002 247.155L57.9284 237.757L52.5002 228.359H41.7065L36.2783 237.757L41.7065 247.155H52.5002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.477 208.418L258.905 199.021L253.477 189.623H242.684L237.255 199.021L242.684 208.418H253.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.973 227.786L292.402 218.388L286.973 208.99H276.18L270.751 218.388L276.18 227.786H286.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.469 247.155L325.898 237.757L320.469 228.359H309.676L304.248 237.757L309.676 247.155H320.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23 218.097L275.648 208.71L270.23 199.312H259.426L254.008 208.71L259.426 218.097H270.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.716 237.467L309.144 228.079L303.716 218.682H292.923L287.505 228.079L292.923 237.467H303.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.485 227.786L191.913 218.388L186.485 208.99H175.691L170.263 218.388L175.691 227.786H186.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.724 218.097L242.152 208.71L236.724 199.312H225.93L220.512 208.71L225.93 218.097H236.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.742 218.097L175.16 208.71L169.742 199.312H158.938L153.52 208.71L158.938 218.097H169.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.238 218.097L208.656 208.71L203.238 199.312H192.434L187.016 208.71L192.434 218.097H203.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.981 208.418L225.409 199.021L219.981 189.623H209.187L203.759 199.021L209.187 208.418H219.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.718 140.625L376.136 131.227L370.718 121.84H359.914L354.497 131.227L359.914 140.625H370.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75 159.994L108.167 150.607L102.75 141.209H91.9455L86.5278 150.607L91.9455 159.994H102.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 169.682L91.425 160.284L85.9968 150.887H75.203L69.7749 160.284L75.203 169.682H85.9968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.989 169.682L158.417 160.284L152.989 150.887H142.195L136.767 160.284L142.195 169.682H152.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.493 169.682L124.921 160.284L119.493 150.887H108.699L103.271 160.284L108.699 169.682H119.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5405 112.15C42.6315 118.501 43.4522 124.98 45.916 130.904H52.5006L57.9287 121.527L52.5006 112.15H43.5405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5003 131.518H46.1553C48.5203 137.196 51.8543 142.103 54.4902 146.927L57.9597 140.915L52.5003 131.518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4495 121.84L53.0317 131.227L58.4495 140.625H69.2536L74.6714 131.227L69.2536 121.84H58.4495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.699 131.518L103.271 140.915L108.699 150.313H119.493L124.921 140.915L119.493 131.518H108.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6714 150.605L69.2536 141.229H58.4494L54.7925 147.563C56.8762 151.616 58.5015 155.627 58.5224 160.066H69.2536L74.6714 150.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 150.313L91.425 140.915L85.9968 131.518H75.203L69.7749 140.915L75.203 150.313H85.9968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.493 189.049L124.921 179.652L119.493 170.254H108.699L103.271 179.652L108.699 189.049H119.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 189.049L91.425 179.652L85.9968 170.254H75.203L69.7749 179.652L75.203 189.049H85.9968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9455 121.84L86.5278 131.227L91.9455 140.625H102.75L108.167 131.227L102.75 121.84H91.9455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.938 141.209L153.52 150.607L158.938 159.994H169.742L175.16 150.607L169.742 141.209H158.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.246 179.361L141.664 169.974L136.246 160.576H125.442L120.024 169.974L125.442 179.361H136.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75 179.361L108.167 169.974L102.75 160.576H91.9455L86.5278 169.974L91.9455 179.361H102.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.203 112.15L69.7749 121.548L75.203 130.946H85.9968L91.425 121.548L85.9968 112.15H75.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4495 102.473L53.0317 111.86L58.4495 121.258H69.2536L74.6714 111.86L69.2536 102.473H58.4495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.292 92.7812C46.7707 98.4918 44.4982 104.883 43.624 111.535H52.5008L57.9289 102.158L52.5008 92.7812H50.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.254 179.363L74.6717 169.986L69.254 160.609H58.5123C58.2797 164.866 56.8773 168.976 54.4595 172.487L58.4498 179.394L69.254 179.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.246 159.994L141.664 150.607L136.246 141.209H125.442L120.024 150.607L125.442 159.994H136.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.001 34.3658L326.419 43.7426H337.212L342.641 34.3658L341.099 31.6882C337.358 29.4169 333.285 27.1664 328.825 24.9785H326.419L321.001 34.3658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.716 276.785H292.923L287.505 286.162L292.923 295.539H297.694C300.351 293.997 303.227 292.465 306.352 290.986L309.144 286.152L303.716 276.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.691 34.103H186.443L191.871 24.7262L190.986 23.2051C188.902 24.372 186.995 25.5493 185.276 26.737C181.744 29.1854 178.462 31.3942 175.253 33.4467L175.691 34.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.691 131.518L170.263 140.915L175.691 150.313H186.485L191.913 140.915L186.485 131.518H175.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.966 267.096H343.172L337.744 276.473L339.932 280.265C346.022 279.211 352.176 278.568 358.352 278.337L359.394 276.493L353.966 267.096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.552 236.84C426.551 231.928 425.978 227.033 424.844 222.254L421.489 228.068L426.552 236.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.734 315.521H225.93L220.491 324.898L221.231 326.159C227.616 327.567 234.178 328.003 240.693 327.451L242.162 324.898L236.734 315.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.53 7.72372C251.401 7.67474 245.275 7.98784 239.183 8.6614L242.704 14.7355H253.498L257.53 7.72372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.469 267.096H309.676L304.248 276.473L309.676 285.849H318.896C319.553 285.62 320.199 285.381 320.865 285.162L325.898 276.452L320.469 267.096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.684 34.1039H253.477L258.905 24.7063L253.477 15.3086H242.684L237.255 24.7063L242.684 34.1039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.195 53.474H152.989L158.417 44.0972L157.917 43.2324C152.781 45.7121 147.155 48.0875 140.497 50.5255L142.195 53.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4496 101.886H69.2538L74.6715 92.5096L69.2538 83.1328H58.8351L58.1266 83.7579L53.084 92.4992L58.4496 101.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.238 159.994L208.656 150.607L203.238 141.209H192.434L187.016 150.607L192.434 159.994H203.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.691 150.887L170.263 160.284L175.691 169.682H186.485L191.913 160.284L186.485 150.887H175.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9455 82.5173H102.75L108.167 73.1405L102.75 63.7637H99.4574C96.1998 64.8055 93.0916 65.8474 90.1327 66.8893L86.5278 73.1405L91.9455 82.5173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1757 266.814L35.758 257.438H24.9538L19.9424 266.127C21.9033 269.872 24.4497 273.28 27.4855 276.222H35.758L41.1757 266.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.493 267.096H108.699L103.271 276.473L108.605 285.714C111.089 285.56 113.58 285.613 116.055 285.87H119.493L124.921 276.493L119.493 267.096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1758 189.341L40.3423 187.893C35.7893 191.747 31.2051 195.123 27.0376 198.728H35.7164L41.1758 189.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.699 72.841H119.493L124.921 63.4641L121.222 57.0566C117.669 58.1714 113.929 59.3383 109.762 60.5573C107.74 61.1616 105.782 61.7555 103.865 62.3493L103.219 63.4641L108.699 72.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4325 237.756L19.0044 228.379H12.1802C12.0775 231.013 12.1471 233.651 12.3885 236.276C12.7323 240.204 13.2116 243.819 13.8159 247.174H19.0252L24.4325 237.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9284 276.496L52.5002 267.119H41.7065L36.2783 276.496L41.3731 285.31C41.8002 285.508 42.2378 285.706 42.6858 285.894H52.5002L57.9284 276.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.923 121.84L287.505 131.227L292.923 140.625H303.716L309.144 131.227L303.716 121.84H292.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.426 141.209L254.008 150.607L259.426 159.994H270.23L275.648 150.607L270.23 141.209H259.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18 131.518L270.751 140.915L276.18 150.313H286.973L292.402 140.915L286.973 131.518H276.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.187 131.518L203.759 140.915L209.187 150.313H219.981L225.409 140.915L219.981 131.518H209.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.684 131.518L237.255 140.915L242.684 150.313H253.477L258.905 140.915L253.477 131.518H242.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93 141.209L220.512 150.607L225.93 159.994H236.724L242.152 150.607L236.724 141.209H225.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.716 198.73L309.144 189.343L303.716 179.945H292.923L287.505 189.343L292.923 198.73H303.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.973 189.049L292.402 179.652L286.973 170.254H276.18L270.751 179.652L276.18 189.049H286.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.716 160.576H292.923L287.505 169.974L292.923 179.361H303.716L309.144 169.974L303.716 160.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.716 141.209H292.923L287.505 150.607L292.923 159.994H303.716L309.144 150.607L303.716 141.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.469 150.313L325.898 140.915L320.469 131.518H309.676L304.248 140.915L309.676 150.313H320.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.699 92.7812L103.271 102.179L108.699 111.577H119.493L124.921 102.179L119.493 92.7812H108.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9455 83.1035L86.5278 92.4908L91.9455 101.888H102.75L108.167 92.4908L102.75 83.1035H91.9455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.203 73.4141L69.7749 82.8117L75.203 92.2094H85.9968L91.425 82.8117L85.9968 73.4141H75.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2538 82.5194L74.6299 73.2051C69.2283 75.6852 64.1484 78.8129 59.502 82.5194H69.2538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.938 121.84L153.52 131.227L158.938 140.625H169.742L175.16 131.227L169.742 121.84H158.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.442 102.473L120.024 111.86L125.442 121.258H136.246L141.664 111.86L136.246 102.473H125.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.434 121.84L187.016 131.227L192.434 140.625H203.238L208.656 131.227L203.238 121.84H192.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.691 112.15L170.263 121.548L175.691 130.946H186.485L191.913 121.548L186.485 112.15H175.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.195 112.15L136.767 121.548L142.195 130.946H152.989L158.417 121.548L152.989 112.15H142.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 198.73L74.6714 189.343L69.2536 179.945H58.4495L53.0317 189.343L58.4495 198.73H69.2536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6665 92.2097H52.5002L56.6052 85.0938C54.3734 87.2433 52.3821 89.6294 50.6665 92.2097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.493 208.418L124.921 199.021L119.493 189.623H108.699L103.271 199.021L108.699 208.418H119.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.195 131.518L136.767 140.915L142.195 150.313H152.989L158.417 140.915L152.989 131.518H142.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 208.418L91.425 199.021L85.9968 189.623H75.203L69.7749 199.021L75.203 208.418H85.9968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75 198.73L108.167 189.343L102.75 179.945H91.9455L86.5278 189.343L91.9455 198.73H102.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5003 189.052L57.9285 179.675L54.1256 173.018C53.9068 173.361 53.6776 173.705 53.4276 174.059C49.8069 179.061 45.5675 183.584 40.8105 187.52L41.7066 189.073L52.5003 189.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.699 112.15L103.271 121.548L108.699 130.946H119.493L124.921 121.548L119.493 112.15H108.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.442 121.84L120.024 131.227L125.442 140.625H136.246L141.664 131.227L136.246 121.84H125.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.203 92.7812L69.7749 102.179L75.203 111.577H85.9968L91.425 102.179L85.9968 92.7812H75.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9455 102.473L86.5278 111.86L91.9455 121.258H102.75L108.167 111.86L102.75 102.473H91.9455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.981 169.682L225.409 160.284L219.981 150.887H209.187L203.759 160.284L209.187 169.682H219.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.477 169.682L258.905 160.284L253.477 150.887H242.684L237.255 160.284L242.684 169.682H253.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.724 179.361L242.152 169.974L236.724 160.576H225.93L220.512 169.974L225.93 179.361H236.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23 179.361L275.648 169.974L270.23 160.576H259.426L254.008 169.974L259.426 179.361H270.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.973 169.682L292.402 160.284L286.973 150.887H276.18L270.751 160.284L276.18 169.682H286.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.989 189.049L158.417 179.652L152.989 170.254H142.195L136.767 179.652L142.195 189.049H152.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.246 198.73L141.664 189.343L136.246 179.945H125.442L120.024 189.343L125.442 198.73H136.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.742 179.361L175.16 169.974L169.742 160.576H158.938L153.52 169.974L158.938 179.361H169.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.238 179.361L208.656 169.974L203.238 160.576H192.434L187.016 169.974L192.434 179.361H203.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.485 189.049L191.913 179.652L186.485 170.254H175.691L170.263 179.652L175.691 189.049H186.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.981 189.049L225.409 179.652L219.981 170.254H209.187L203.759 179.652L209.187 189.049H219.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.172 34.1026H344.87C343.995 33.5191 343.099 32.9461 342.171 32.373L343.172 34.1026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.676 34.6777L304.248 44.0754L309.676 53.4731H320.469L325.898 44.0754L320.469 34.6777H309.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.464 170.088C399.703 167.001 398.099 163.826 396.661 160.576H393.41L387.993 169.953L393.41 179.33H404.194L405.444 177.163C404.194 174.871 402.839 172.495 401.464 170.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.923 24.998L287.505 34.3957L292.923 43.783H303.716L309.144 34.3957L303.716 24.998H292.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18 34.6777L270.751 44.0754L276.18 53.4731H286.973L292.402 44.0754L286.973 34.6777H276.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.204 198.73L409.632 189.343L404.204 179.945H393.41L387.993 189.343L393.41 198.73H404.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.461 208.99H376.667L371.239 218.388L376.667 227.786H387.461L392.889 218.388L387.461 208.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.461 228.359H376.667L371.239 237.757L376.667 247.155H387.461L392.889 237.757L387.461 228.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.461 189.623H376.667L371.239 199.021L376.667 208.418H387.461L392.889 199.021L387.461 189.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.426 44.3672L254.008 53.7544L259.426 63.1521H270.23L275.648 53.7544L270.23 44.3672H259.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.485 305.258L191.913 295.861L186.485 286.463H175.691L170.263 295.861L175.691 305.258H186.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.684 34.6777L237.255 44.0754L242.684 53.4731H253.477L258.905 44.0754L253.477 34.6777H242.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.989 286.496H142.195L138.642 292.654C144.081 294.946 149.842 297.602 155.812 300.405L158.417 295.894L152.989 286.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.461 247.727H376.667L371.239 257.124L376.667 266.522H387.461L392.889 257.124L387.461 247.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.981 285.891L225.409 276.493L219.981 267.096H209.187L203.759 276.493L209.187 285.891H219.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.238 295.57L208.656 286.183L203.238 276.785H192.434L187.016 286.183L192.434 295.57H203.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.742 295.57L175.16 286.183L169.742 276.785H158.938L153.52 286.183L158.938 295.57H169.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.938 43.7409H169.773L175.191 34.3641L174.826 33.7285C169.561 37.1044 164.106 40.176 158.49 42.9282L158.938 43.7409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93 44.3672L220.512 53.7544L225.93 63.1521H236.724L242.152 53.7544L236.724 44.3672H225.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.187 34.6777L203.759 44.0754L209.187 53.4731H219.981L225.409 44.0754L219.981 34.6777H209.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.434 24.998L187.016 34.3957L192.434 43.783H203.238L208.656 34.3957L203.238 24.998H192.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.667 267.096L371.239 276.473L372.281 278.192C379.574 278.296 386.148 278.504 392.077 277.931L392.921 276.473L387.492 267.096H376.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2578 290.382L85.997 286.496H75.2032L71.4004 293.091C77.1255 293.061 82.8116 292.148 88.2578 290.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75 276.785H91.9455L86.5278 286.162L88.8512 290.184C94.967 288.371 100.895 286.297 107.938 285.756L102.75 276.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.989 285.891L158.417 276.493L152.989 267.096H142.195L136.767 276.493L142.195 285.891H152.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.246 276.785H125.442L120.024 286.162L120.212 286.485C123.61 287.132 126.948 288.059 130.193 289.256C132.725 290.184 135.402 291.236 138.08 292.382L141.664 286.131L136.246 276.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 276.785H58.4495L53.0317 286.162L55.3968 290.257C56.7408 290.642 58.0952 291.017 59.5643 291.382C63.223 292.352 66.9808 292.901 70.7644 293.017L74.7235 286.162L69.2536 276.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.434 44.3672L187.016 53.7544L192.434 63.1521H203.238L208.656 53.7544L203.238 44.3672H192.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.691 34.6777L170.263 44.0754L175.691 53.4731H186.485L191.913 44.0754L186.485 34.6777H175.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.187 54.0449L203.759 63.4426L209.187 72.8402H219.981L225.409 63.4426L219.981 54.0449H209.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.742 276.203L175.16 266.816L169.742 257.418H158.938L153.52 266.816L158.938 276.203H169.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.938 44.3672L153.52 53.7544L158.938 63.1521H169.742L175.16 53.7544L169.742 44.3672H158.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.676 286.494L307.3 290.578C310.353 289.161 313.645 287.786 317.24 286.463L309.676 286.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23 276.203L275.648 266.816L270.23 257.418H259.426L254.008 266.816L259.426 276.203H270.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.973 285.891L292.402 276.493L286.973 267.096H276.18L270.751 276.493L276.18 285.891H286.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.485 285.891L191.913 276.493L186.485 267.096H175.691L170.263 276.493L175.691 285.891H186.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.786 277.868C394.89 277.66 396.979 277.312 399.037 276.826H393.4L392.786 277.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.724 295.57L242.152 286.183L236.724 276.785H225.93L220.512 286.183L225.93 295.57H236.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.238 276.203L208.656 266.816L203.238 257.418H192.434L187.016 266.816L192.434 276.203H203.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.981 266.522L225.409 257.124L219.981 247.727H209.187L203.759 257.124L209.187 266.522H219.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.477 266.522L258.905 257.124L253.477 247.727H242.684L237.255 257.124L242.684 266.522H253.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.724 276.203L242.152 266.816L236.724 257.418H225.93L220.512 266.816L225.93 276.203H236.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5005 286.496H44.0718C47.5084 287.871 51.0137 289.067 54.5738 290.08L52.5005 286.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23 314.95L275.648 305.552L270.23 296.154H259.426L254.008 305.552L259.426 314.95H270.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.477 305.258L258.905 295.861L253.477 286.463H242.684L237.255 295.861L242.684 305.258H253.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18 305.844L270.918 314.95C274.784 312.126 278.555 309.032 282.692 305.844H276.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.724 314.95L242.152 305.552L236.724 296.154H225.93L220.512 305.552L225.93 314.95H236.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.126 315.521H259.426L254.446 324.148C260.043 322.003 265.319 319.1 270.126 315.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.979 247.727H410.164L404.736 257.103L410.164 266.48H415.488C416.092 265.761 416.686 265.011 417.28 264.209C419.965 260.6 422.132 256.634 423.719 252.425L420.979 247.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.238 315.521H192.434L191.747 316.72C196.956 318.866 202.165 320.814 207.239 322.471L203.238 315.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.913 315.232L186.485 305.855H175.691L173.941 308.887C179.65 311.534 185.401 314.097 191.194 316.503L191.913 315.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.238 296.154H192.434L187.016 305.552L192.434 314.95H203.238L208.656 305.552L203.238 296.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.773 296.154H158.938L156.354 300.624C161.897 303.229 167.606 305.958 173.378 308.636L175.16 305.51L169.773 296.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.981 305.258L225.409 295.861L219.981 286.463H209.187L203.759 295.861L209.187 305.258H219.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.489 247.448L423.979 251.772C425.453 247.586 426.299 243.204 426.49 238.77L421.489 247.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.981 325.203H216.761C218.011 325.516 219.241 325.797 220.47 326.057L219.981 325.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.123 324.63L253.613 324.453L258.937 315.232L253.509 305.855H242.704L237.276 315.232L242.704 324.609L253.123 324.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.979 228.359H410.164L404.736 237.757L410.164 247.155H420.979L426.407 237.757L420.979 228.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.705 325.203L241.444 327.401C242.277 327.297 243.111 327.183 243.934 327.037C246.438 326.576 248.912 325.963 251.342 325.203H242.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.76 208.99H410.164L404.736 218.367L410.164 227.744H420.979L424.646 221.409C423.606 217.194 422.308 213.046 420.76 208.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.008 15.0157L259.426 24.3926H270.23L275.648 15.0157L271.876 8.49364C267.23 8.03521 262.666 7.77475 258.217 7.72266L254.008 15.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.512 15.0149L225.93 24.3917H236.734L242.152 15.0149L238.526 8.76367C233.161 9.36597 227.833 10.2598 222.565 11.4413L220.512 15.0149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.981 324.631L225.409 315.254L219.981 305.877H209.187L203.759 315.254L208.093 322.766C210.26 323.453 212.406 324.089 214.532 324.651L219.981 324.631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.187 15.3086L203.759 24.7063L209.187 34.1039H219.981L225.409 24.7063L219.981 15.3086H209.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.204 218.682H393.41L387.993 228.079L393.41 237.467H404.204L409.632 228.079L404.204 218.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.204 238.049H393.41L387.993 247.446L393.41 256.844H404.204L409.632 247.446L404.204 238.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.41 257.419L387.993 266.795L393.41 276.172H401.068C402.447 275.746 403.794 275.224 405.1 274.609L409.611 266.785L404.194 257.408L393.41 257.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.541 208.418C418.047 202.023 415.219 195.763 412.071 189.664H410.164L404.736 199.041L410.164 208.418H420.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.204 199.312H393.41L387.993 208.71L393.41 218.097H404.204L409.632 208.71L404.204 199.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.164 267.096L406.09 274.149C409.467 272.373 412.481 269.981 414.977 267.096H410.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23 295.57L275.648 286.183L270.23 276.785H259.426L254.008 286.183L259.426 295.57H270.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.441 305.25C285.379 303.77 287.411 302.27 289.557 300.77L292.402 295.873L286.973 286.496H276.18L270.751 295.873L276.18 305.25H283.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.736 179.652L410.164 189.029H411.779C409.924 185.382 407.931 181.635 405.799 177.787L404.736 179.652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.922 296.154L290.703 300.04C292.599 298.749 294.6 297.467 296.736 296.196L292.922 296.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.434 24.4132H203.238L208.374 15.5156C202.567 17.4894 196.941 19.9608 191.559 22.9025L192.434 24.4132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93 24.998L220.512 34.3957L225.93 43.783H236.724L242.152 34.3957L236.724 24.998H225.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.426 24.998L254.008 34.3957L259.426 43.783H270.23L275.648 34.3957L270.23 24.998H259.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.477 285.891L258.905 276.493L253.477 267.096H242.684L237.255 276.493L242.684 285.891H253.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.688 14.735H219.981L221.763 11.6094C217.877 12.5575 214.178 13.5993 210.688 14.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.505 15.0183L292.923 24.3951H303.716L308.342 16.4769C302.23 14.3743 296 12.6348 289.682 11.2676L287.505 15.0183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.676 34.1024H320.469L325.898 24.7255L325.012 23.1836C321.539 21.5652 317.813 19.9954 313.833 18.4743C312.176 17.8388 310.53 17.2449 308.884 16.6719L304.248 24.7047L309.676 34.1024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.418 24.4149H327.637L325.96 23.623L326.418 24.4149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18 14.7362H286.973L289.057 11.1522C283.633 10.0025 278.152 9.13998 272.637 8.56836L276.18 14.7362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18 34.1039H286.973L292.402 24.7063L286.973 15.3086H276.18L270.751 24.7063L276.18 34.1039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18 54.0449L270.751 63.4426L276.18 72.8402H286.973L292.402 63.4426L286.973 54.0449H276.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.212 276.203L342.641 266.816L337.212 257.418H326.419L321.001 266.816L326.419 276.203H337.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.966 189.623H343.172L337.744 199.021L343.172 208.418H353.966L359.394 199.021L353.966 189.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.469 266.522L325.898 257.124L320.469 247.727H309.676L304.248 257.124L309.676 266.522H320.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.966 208.99H343.172L337.744 218.388L343.172 227.786H353.966L359.394 218.388L353.966 208.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.966 228.359H343.172L337.744 237.757L343.172 247.155H353.966L359.394 237.757L353.966 228.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.966 266.522L359.394 257.124L353.966 247.727H343.172L337.744 257.124L343.172 266.522H353.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23 237.467L275.648 228.079L270.23 218.682H259.426L254.008 228.079L259.426 237.467H270.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.477 227.786L258.905 218.388L253.477 208.99H242.684L237.255 218.388L242.684 227.786H253.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.716 256.844L309.144 247.446L303.716 238.049H292.923L287.505 247.446L292.923 256.844H303.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.973 247.155L292.402 237.757L286.973 228.359H276.18L270.751 237.757L276.18 247.155H286.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.914 63.1513H370.708L372.604 59.8694C368.744 54.545 364.318 49.6545 359.404 45.2832L354.497 53.7849L359.914 63.1513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.676 73.4141L304.248 82.8117L309.676 92.2094H320.469L325.898 82.8117L320.469 73.4141H309.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.172 54.0449L337.744 63.4426L343.172 72.8402H353.966L359.394 63.4426L353.966 54.0449H343.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.419 63.7363L321.001 73.134L326.419 82.5212H337.212L342.641 73.134L337.212 63.7363H326.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.923 63.7363L287.505 73.134L292.923 82.5212H303.716L309.144 73.134L303.716 63.7363H292.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.724 237.467L242.152 228.079L236.724 218.682H225.93L220.512 228.079L225.93 237.467H236.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.966 170.254H343.172L337.744 179.652L343.172 189.049H353.966L359.394 179.652L353.966 170.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.718 179.361L376.136 169.974L370.718 160.576H359.914L354.497 169.974L359.914 179.361H370.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.718 141.209H359.914L354.497 150.607L359.914 159.994H370.718L376.136 150.607L370.718 141.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.461 150.313L391.264 143.728C390.743 141.134 390.399 138.623 390.139 136.154L387.461 131.518H376.667L371.239 140.894L376.667 150.271L387.461 150.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.691 73.4141L170.263 82.8117L175.691 92.2094H186.485L191.913 82.8117L186.485 73.4141H175.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0045 208.419L21.2967 204.449C20.1922 205.709 19.1658 207.034 18.2231 208.419H19.0045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75 63.1505L103.073 62.5879L101.281 63.1505H102.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4324 257.125L19.0042 247.748H13.9199C14.9483 253.896 16.8645 259.863 19.6085 265.46L24.4324 257.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0046 227.789L24.4327 218.412L19.0046 209.035H17.8585C14.3159 214.662 12.3611 221.142 12.2012 227.789H19.0046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.442 63.7363L120.024 73.134L125.442 82.5212H136.246L141.664 73.134L136.246 63.7363H125.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.195 73.4141L136.767 82.8117L142.195 92.2094H152.989L158.417 82.8117L152.989 73.4141H142.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5002 266.522L57.9284 257.124L52.5002 247.727H41.7065L36.2783 257.124L41.7065 266.522H52.5002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.434 83.1035L187.016 92.4908L192.434 101.888H203.238L208.656 92.4908L203.238 83.1035H192.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18 73.4141L270.751 82.8117L276.18 92.2094H286.973L292.402 82.8117L286.973 73.4141H276.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.938 83.1035L153.52 92.4908L158.938 101.888H169.742L175.16 92.4908L169.742 83.1035H158.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.742 237.467L175.16 228.079L169.742 218.682H158.938L153.52 228.079L158.938 237.467H169.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 256.844L74.6714 247.446L69.2536 238.049H58.4495L53.0317 247.446L58.4495 256.844H69.2536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.989 247.155L158.417 237.757L152.989 228.359H142.195L136.767 237.757L142.195 247.155H152.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93 63.7363L220.512 73.134L225.93 82.5212H236.724L242.152 73.134L236.724 63.7363H225.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.238 237.467L208.656 228.079L203.238 218.682H192.434L187.016 228.079L192.434 237.467H203.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.981 227.786L225.409 218.388L219.981 208.99H209.187L203.759 218.388L209.187 227.786H219.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 266.522L91.425 257.124L85.9968 247.727H75.203L69.7749 257.124L75.203 266.522H85.9968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75 256.844L108.167 247.446L102.75 238.049H91.9455L86.5278 247.446L91.9455 256.844H102.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.493 266.522L124.921 257.124L119.493 247.727H108.699L103.271 257.124L108.699 266.522H119.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.246 256.844L141.664 247.446L136.246 238.049H125.442L120.024 247.446L125.442 256.844H136.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.485 247.155L191.913 237.757L186.485 228.359H175.691L170.263 237.757L175.691 247.155H186.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.718 238.049H359.914L354.497 247.446L359.914 256.844H370.718L376.136 247.446L370.718 238.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.718 218.682H359.914L354.497 228.079L359.914 237.467H370.718L376.136 228.079L370.718 218.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.718 199.312H359.914L354.497 208.71L359.914 218.097H370.718L376.136 208.71L370.718 199.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.718 257.418H359.914L354.497 266.816L359.914 276.203H370.718L376.136 266.816L370.718 257.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.718 179.945H359.914L354.497 189.343L359.914 198.73H370.718L376.136 189.343L370.718 179.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.973 266.522L292.402 257.124L286.973 247.727H276.18L270.751 257.124L276.18 266.522H286.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.716 276.203L309.144 266.816L303.716 257.418H292.923L287.505 266.816L292.923 276.203H303.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.461 189.049L392.889 179.652L387.461 170.254H376.667L371.239 179.652L376.667 189.049H387.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.531 278.161L370.708 276.744H359.914L359.039 278.276C363.425 278.161 367.593 278.161 371.531 278.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.306 280.4L337.223 276.785H326.419L321.72 284.922C322.907 284.526 324.116 284.141 325.356 283.766C329.939 282.381 334.596 281.257 339.306 280.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.744 44.0748L343.172 53.4516H353.966L358.946 44.8145C354.787 41.1255 350.376 37.7312 345.745 34.6562H343.172L337.744 44.0748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.426 83.1035L254.008 92.4908L259.426 101.888H270.23L275.648 92.4908L270.23 83.1035H259.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.187 92.7812L203.759 102.179L209.187 111.577H219.981L225.409 102.179L219.981 92.7812H209.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.684 54.0449L237.255 63.4426L242.684 72.8402H253.477L258.905 63.4426L253.477 54.0449H242.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.923 44.3672L287.505 53.7544L292.923 63.1521H303.716L309.144 53.7544L303.716 44.3672H292.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.419 44.3672L321.001 53.7544L326.419 63.1521H337.212L342.641 53.7544L337.212 44.3672H326.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.676 54.0449L304.248 63.4426L309.676 72.8402H320.469L325.898 63.4426L320.469 54.0449H309.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.401 159.99C394.232 155.042 392.574 149.886 391.452 144.602L387.993 150.603L393.41 159.98L396.401 159.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23 256.844L275.648 247.446L270.23 238.049H259.426L254.008 247.446L259.426 256.844H270.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.461 150.887H376.667L371.239 160.284L376.667 169.682H387.461L392.889 160.284L387.461 150.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.426 63.7363L254.008 73.134L259.426 82.5212H270.23L275.648 73.134L270.23 63.7363H259.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.477 247.155L258.905 237.757L253.477 228.359H242.684L237.255 237.757L242.684 247.155H253.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.938 63.7363L153.52 73.134L158.938 82.5212H169.742L175.16 73.134L169.742 63.7363H158.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.848 56.8462L125.484 63.0975H136.288L141.706 53.7206L139.966 50.6992C134.631 52.6788 128.682 54.6792 121.848 56.8462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.691 54.0449L170.263 63.4426L175.691 72.8402H186.485L191.913 63.4426L186.485 54.0449H175.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7577 276.785H28.0791C31.7401 280.105 35.8946 282.836 40.394 284.881L35.7577 276.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2536 276.203L74.6714 266.816L69.2536 257.418H58.4495L53.0317 266.816L58.4495 276.203H69.2536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.684 73.4141L237.255 82.8117L242.684 92.2094H253.477L258.905 82.8117L253.477 73.4141H242.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.434 63.7363L187.016 73.134L192.434 82.5212H203.238L208.656 73.134L203.238 63.7363H192.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93 83.1035L220.512 92.4908L225.93 101.888H236.724L242.152 92.4908L236.724 83.1035H225.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.187 73.4141L203.759 82.8117L209.187 92.2094H219.981L225.409 82.8117L219.981 73.4141H209.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.195 54.0449L136.767 63.4426L142.195 72.8402H152.989L158.417 63.4426L152.989 54.0449H142.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.238 256.844L208.656 247.446L203.238 238.049H192.434L187.016 247.446L192.434 256.844H203.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.981 247.155L225.409 237.757L219.981 228.359H209.187L203.759 237.757L209.187 247.155H219.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.724 256.844L242.152 247.446L236.724 238.049H225.93L220.512 247.446L225.93 256.844H236.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9968 285.891L91.425 276.493L85.9968 267.096H75.203L69.7749 276.493L75.203 285.891H85.9968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.485 266.522L191.913 257.124L186.485 247.727H175.691L170.263 257.124L175.691 266.522H186.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.742 256.844L175.16 247.446L169.742 238.049H158.938L153.52 247.446L158.938 256.844H169.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75 276.203L108.167 266.816L102.75 257.418H91.9455L86.5278 266.816L91.9455 276.203H102.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.246 276.203L141.664 266.816L136.246 257.418H125.442L120.024 266.816L125.442 276.203H136.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.989 266.522L158.417 257.124L152.989 247.727H142.195L136.767 257.124L142.195 266.522H152.989Z",
    fill: "white"
  }))), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M349.798 346.588L272.574 326.793H345.474L424.458 346.588H349.798Z",
    fill: "#026CE3"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6604 346.588L151.884 326.793H78.9945L0 346.588H74.6604Z",
    fill: "#026CE3"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M215.793 264.243C215.793 264.243 215.72 263.878 215.605 263.201",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M215.261 261.158C214.146 253.938 212.261 235.924 219.335 227.881C228.305 217.702 239.057 226.422 269.022 227.881C298.986 229.339 314.405 224.974 314.718 199.281C315.031 173.589 297.454 171.891 297.454 171.891H286.348",
    stroke: "#2E353A",
    strokeMiterlimit: 10,
    strokeDasharray: "2.01 2.01"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M285.295 171.932H284.253",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M284.253 93.0098H285.295",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M287.379 93.0098H324.886C324.886 93.0098 336.19 93.9891 335.722 107.033C335.253 120.078 316.447 132.299 317.645 158.345C318.843 184.392 363.289 180.506 369.343 206.584C375.396 232.662 330.929 231.36 326.793 244.821C325.493 247.838 324.853 251.1 324.917 254.385C324.917 258.761 324.917 269.159 324.917 273.607",
    stroke: "#2E353A",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M324.918 274.66V275.702",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M146.185 19.1836H145.143",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M143.07 19.184H124.702C124.702 19.184 74.6924 18.611 74.6924 60.8588C74.6924 80.4147 81.4854 95.0321 101.614 119.058C121.743 143.083 121.41 218.181 114.867 231.652C108.324 245.124 94.4462 243.113 89.5703 250.406C89.5703 250.406 86.0592 254.084 85.757 258.574C85.5174 262.106 85.6529 273.681 85.757 278.432",
    stroke: "#2E353A",
    strokeMiterlimit: 10,
    strokeDasharray: "1.99 1.99"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7046 279.525C85.7046 280.182 85.7046 280.567 85.7046 280.567",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M157.427 73.5789C155.176 73.5822 152.966 74.1788 151.019 75.3084C151.199 74.3078 151.29 73.2932 151.29 72.2765C151.294 67.8611 149.648 63.6035 146.675 60.3385C143.703 57.0736 139.618 55.0367 135.221 54.6272C130.825 54.2176 126.434 55.465 122.909 58.1248C119.385 60.7846 116.981 64.6649 116.169 69.0051C114.031 68.2248 111.749 67.9209 109.481 68.1145C107.214 68.3081 105.016 68.9946 103.041 70.126C101.067 71.2574 99.3629 72.8064 98.0492 74.6647C96.7356 76.523 95.8436 78.6458 95.4357 80.8847C95.0278 83.1236 95.1138 85.4245 95.6876 87.6267C96.2615 89.8289 97.3094 91.8792 98.7581 93.6343C100.207 95.3894 102.021 96.8069 104.075 97.7878C106.128 98.7687 108.371 99.2892 110.647 99.313H157.437C160.85 99.313 164.123 97.9574 166.536 95.5444C168.949 93.1313 170.304 89.8585 170.304 86.446C170.304 83.0334 168.949 79.7606 166.536 77.3476C164.123 74.9345 160.85 73.5789 157.437 73.5789H157.427Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M355.226 125.861C352.826 125.863 350.469 126.495 348.391 127.695C348.575 126.632 348.669 125.555 348.672 124.476C348.674 119.776 346.92 115.245 343.755 111.771C340.59 108.297 336.242 106.13 331.562 105.694C326.883 105.259 322.209 106.586 318.457 109.417C314.706 112.247 312.146 116.377 311.28 120.996C308.997 120.149 306.556 119.812 304.129 120.009C301.702 120.206 299.348 120.933 297.232 122.138C295.116 123.342 293.289 124.996 291.881 126.982C290.472 128.969 289.516 131.24 289.08 133.635C288.643 136.031 288.737 138.493 289.354 140.848C289.971 143.204 291.096 145.396 292.651 147.27C294.206 149.143 296.153 150.654 298.354 151.695C300.556 152.735 302.958 153.281 305.393 153.294H355.226C358.859 153.294 362.344 151.85 364.914 149.281C367.483 146.712 368.926 143.227 368.926 139.593C368.926 135.96 367.483 132.475 364.914 129.906C362.344 127.336 358.859 125.893 355.226 125.893V125.861Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M346.37 156.783H350.537",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M326.053 156.783H340.639",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M312.259 106.452C314.392 104.659 317.026 103.567 319.802 103.326",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M307.3 114.067C307.675 112.42 308.384 110.867 309.384 109.504",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M149.092 189.292C145.485 189.295 141.942 190.247 138.819 192.053C139.104 190.454 139.247 188.833 139.246 187.208C139.251 180.145 136.617 173.334 131.86 168.111C127.103 162.889 120.567 159.633 113.533 158.98C106.5 158.328 99.476 160.327 93.8401 164.586C88.2041 168.844 84.3624 175.055 83.0686 181.999C79.6469 180.744 75.9921 180.251 72.3602 180.556C68.7282 180.862 65.2069 181.957 62.0429 183.766C58.8788 185.576 56.1485 188.055 54.0432 191.03C51.9378 194.005 50.5084 197.404 49.8549 200.99C49.2014 204.576 49.3397 208.261 50.2601 211.788C51.1805 215.314 52.8607 218.597 55.1831 221.406C57.5055 224.215 60.4139 226.483 63.7046 228.05C66.9954 229.616 70.5889 230.445 74.2335 230.477H149.092C154.47 230.356 159.588 228.135 163.349 224.288C167.11 220.441 169.216 215.275 169.216 209.895C169.216 204.515 167.11 199.349 163.349 195.502C159.588 191.656 154.47 189.434 149.092 189.313V189.292Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0112 228.379C56.0594 229.075 57.1562 229.695 58.2931 230.233",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8325 218.775C47.8304 221.148 49.2813 223.303 51.1042 225.12",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0186 157.304C97.346 154.326 102.536 152.861 107.782 153.136",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5073 161.473C89.2335 160.524 90.0577 159.655 90.9661 158.879",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M284.254 87.248H279.305V100.334H284.254V87.248Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M284.254 164.441H279.305V177.527H284.254V164.441Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M151.134 11.5332H146.185V24.6191H151.134V11.5332Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M151.134 126.34H146.185V139.426H151.134V126.34Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M280.93 4.29492H150.666V32.5087H280.93V4.29492Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M246.705 11.4941H156.927V25.3093H246.705V11.4941Z",
    fill: "#026CE3",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M258.863 21.278C260.785 21.278 262.343 19.7201 262.343 17.7982C262.343 15.8763 260.785 14.3184 258.863 14.3184C256.941 14.3184 255.383 15.8763 255.383 17.7982C255.383 19.7201 256.941 21.278 258.863 21.278Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M275.982 17.7982C275.982 17.11 275.778 16.4372 275.395 15.8649C275.013 15.2926 274.469 14.8466 273.833 14.5832C273.198 14.3199 272.498 14.251 271.823 14.3852C271.148 14.5195 270.528 14.8509 270.041 15.3376C269.555 15.8242 269.223 16.4443 269.089 17.1193C268.955 17.7943 269.023 18.494 269.287 19.1299C269.55 19.7657 269.996 20.3092 270.568 20.6916C271.141 21.074 271.814 21.278 272.502 21.278C273.425 21.278 274.31 20.9114 274.962 20.2588C275.615 19.6062 275.982 18.7211 275.982 17.7982Z",
    fill: "#026CE3",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M238.557 21.278C240.479 21.278 242.037 19.7201 242.037 17.7982C242.037 15.8763 240.479 14.3184 238.557 14.3184C236.636 14.3184 235.078 15.8763 235.078 17.7982C235.078 19.7201 236.636 21.278 238.557 21.278Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M275.992 32.5059H155.614V42.164H275.992V32.5059Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M280.93 42.1641H150.666V70.3779H280.93V42.1641Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M246.705 49.3633H156.927V63.1785H246.705V49.3633Z",
    fill: "#026CE3",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M258.863 59.1589C260.785 59.1589 262.343 57.6009 262.343 55.6791C262.343 53.7572 260.785 52.1992 258.863 52.1992C256.941 52.1992 255.383 53.7572 255.383 55.6791C255.383 57.6009 256.941 59.1589 258.863 59.1589Z",
    fill: "#026CE3",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M275.982 55.6791C275.982 54.9908 275.778 54.318 275.395 53.7458C275.013 53.1735 274.469 52.7275 273.833 52.4641C273.198 52.2007 272.498 52.1318 271.823 52.2661C271.148 52.4004 270.528 52.7318 270.041 53.2184C269.555 53.7051 269.223 54.3252 269.089 55.0002C268.955 55.6752 269.023 56.3749 269.287 57.0107C269.55 57.6466 269.996 58.1901 270.568 58.5724C271.141 58.9548 271.814 59.1589 272.502 59.1589C272.959 59.1603 273.412 59.0712 273.835 58.8968C274.258 58.7224 274.642 58.4662 274.966 58.1428C275.289 57.8193 275.545 57.4352 275.72 57.0124C275.894 56.5895 275.983 56.1364 275.982 55.6791Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M238.557 59.1589C240.479 59.1589 242.037 57.6009 242.037 55.6791C242.037 53.7572 240.479 52.1992 238.557 52.1992C236.636 52.1992 235.078 53.7572 235.078 55.6791C235.078 57.6009 236.636 59.1589 238.557 59.1589Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M275.992 70.3867H155.614V80.0449H275.992V70.3867Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M280.93 80.0488H150.666V108.263H280.93V80.0488Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M246.705 87.248H156.927V101.063H246.705V87.248Z",
    fill: "#026CE3",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M258.863 97.028C260.785 97.028 262.343 95.4701 262.343 93.5482C262.343 91.6263 260.785 90.0684 258.863 90.0684C256.941 90.0684 255.383 91.6263 255.383 93.5482C255.383 95.4701 256.941 97.028 258.863 97.028Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M275.982 93.5482C275.982 92.86 275.778 92.1872 275.395 91.6149C275.013 91.0426 274.469 90.5966 273.833 90.3332C273.198 90.0699 272.498 90.001 271.823 90.1352C271.148 90.2695 270.528 90.6009 270.041 91.0876C269.555 91.5742 269.223 92.1943 269.089 92.8693C268.955 93.5443 269.023 94.244 269.287 94.8799C269.55 95.5157 269.996 96.0592 270.568 96.4416C271.141 96.824 271.814 97.028 272.502 97.028C273.425 97.028 274.31 96.6614 274.962 96.0088C275.615 95.3562 275.982 94.4711 275.982 93.5482Z",
    fill: "#026CE3",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M238.557 97.028C240.479 97.028 242.037 95.4701 242.037 93.5482C242.037 91.6263 240.479 90.0684 238.557 90.0684C236.636 90.0684 235.078 91.6263 235.078 93.5482C235.078 95.4701 236.636 97.028 238.557 97.028Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M275.992 108.262H155.614V117.92H275.992V108.262Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M280.93 117.918H150.666V146.132H280.93V117.918Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M246.705 125.119H156.927V138.934H246.705V125.119Z",
    fill: "#026CE3",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M258.863 134.911C260.785 134.911 262.343 133.353 262.343 131.431C262.343 129.509 260.785 127.951 258.863 127.951C256.941 127.951 255.383 129.509 255.383 131.431C255.383 133.353 256.941 134.911 258.863 134.911Z",
    fill: "#026CE3",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M275.982 131.431C275.982 130.743 275.778 130.07 275.395 129.498C275.013 128.925 274.469 128.479 273.833 128.216C273.198 127.953 272.498 127.884 271.823 128.018C271.148 128.152 270.528 128.484 270.041 128.97C269.555 129.457 269.223 130.077 269.089 130.752C268.955 131.427 269.023 132.127 269.287 132.763C269.55 133.399 269.996 133.942 270.568 134.324C271.141 134.707 271.814 134.911 272.502 134.911C272.959 134.912 273.412 134.823 273.835 134.649C274.258 134.474 274.642 134.218 274.966 133.895C275.289 133.571 275.545 133.187 275.72 132.764C275.894 132.342 275.983 131.888 275.982 131.431Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M238.557 134.911C240.479 134.911 242.037 133.353 242.037 131.431C242.037 129.509 240.479 127.951 238.557 127.951C236.636 127.951 235.078 129.509 235.078 131.431C235.078 133.353 236.636 134.911 238.557 134.911Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M275.992 146.143H155.614V155.801H275.992V146.143Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M280.93 155.801H150.666V184.015H280.93V155.801Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M246.705 163H156.927V176.815H246.705V163Z",
    fill: "#026CE3",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M258.863 172.784C260.785 172.784 262.343 171.226 262.343 169.304C262.343 167.382 260.785 165.824 258.863 165.824C256.941 165.824 255.383 167.382 255.383 169.304C255.383 171.226 256.941 172.784 258.863 172.784Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M275.982 169.304C275.982 168.616 275.778 167.943 275.395 167.371C275.013 166.799 274.469 166.352 273.833 166.089C273.198 165.826 272.498 165.757 271.823 165.891C271.148 166.025 270.528 166.357 270.041 166.843C269.555 167.33 269.223 167.95 269.089 168.625C268.955 169.3 269.023 170 269.287 170.636C269.55 171.272 269.996 171.815 270.568 172.197C271.141 172.58 271.814 172.784 272.502 172.784C273.425 172.784 274.31 172.417 274.962 171.765C275.615 171.112 275.982 170.227 275.982 169.304Z",
    fill: "#026CE3",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M238.557 172.784C240.479 172.784 242.037 171.226 242.037 169.304C242.037 167.382 240.479 165.824 238.557 165.824C236.636 165.824 235.078 167.382 235.078 169.304C235.078 171.226 236.636 172.784 238.557 172.784Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M224.471 0.5H231.764",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M173.94 0.5H216.136",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M145.289 171.889V177.098",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M145.289 155.74V166.68",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M337.42 59.4627L330.127 45.0328C330.086 44.9321 330.025 44.8408 329.947 44.7648C329.869 44.6887 329.777 44.6295 329.675 44.5908C329.573 44.5521 329.465 44.5348 329.356 44.5399C329.247 44.5451 329.141 44.5725 329.043 44.6206C328.946 44.6687 328.859 44.7363 328.789 44.8193C328.719 44.9024 328.666 44.999 328.635 45.1031C328.604 45.2073 328.594 45.3168 328.607 45.4248C328.62 45.5328 328.655 45.637 328.71 45.7309L335.68 60.3171C335.537 60.4644 335.438 60.6487 335.394 60.8493C335.349 61.0499 335.362 61.2589 335.43 61.4527L342.807 75.2783C343.004 75.6742 343.63 75.7576 344.223 75.4658C344.817 75.1741 345.13 74.6219 344.932 74.2364L338.472 59.9524C338.365 59.7756 338.208 59.6347 338.021 59.5475C337.833 59.4603 337.624 59.4308 337.42 59.4627Z",
    fill: "#2E353A"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M377.803 59.4633L385.148 45.0334C385.238 44.8471 385.398 44.704 385.594 44.6357C385.789 44.5673 386.004 44.5792 386.19 44.6688C386.373 44.7628 386.512 44.9232 386.58 45.117C386.648 45.3109 386.639 45.5233 386.555 45.7106L379.574 60.2968C379.721 60.4422 379.82 60.6277 379.861 60.8298C379.902 61.032 379.882 61.2417 379.803 61.4325L372.427 75.2581C372.229 75.654 371.593 75.7373 371.01 75.4456C370.427 75.1539 370.104 74.6017 370.291 74.2162L376.761 59.9322C376.87 59.761 377.027 59.6255 377.212 59.5422C377.397 59.4589 377.603 59.4315 377.803 59.4633Z",
    fill: "#2E353A"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M380.595 75.9028H334.784L338.222 70.0684H377.157L380.595 75.9028Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M380.585 75.9043H334.784V81.7388H380.585V75.9043Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M356.893 80.1144H339.285C338.944 80.1117 338.618 79.9744 338.378 79.7324C338.138 79.4904 338.003 79.1634 338.003 78.8225C338.003 78.4826 338.138 78.1567 338.379 77.9164C338.619 77.676 338.945 77.541 339.285 77.541H356.893C357.232 77.541 357.558 77.676 357.799 77.9164C358.039 78.1567 358.174 78.4826 358.174 78.8225C358.174 79.1634 358.039 79.4904 357.799 79.7324C357.559 79.9744 357.233 80.1117 356.893 80.1144Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M367.55 79.7915C368.172 79.7915 368.676 79.2877 368.676 78.6662C368.676 78.0448 368.172 77.541 367.55 77.541C366.929 77.541 366.425 78.0448 366.425 78.6662C366.425 79.2877 366.929 79.7915 367.55 79.7915Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M373.344 78.663C373.344 78.4384 373.277 78.2188 373.153 78.0321C373.028 77.8453 372.85 77.6997 372.643 77.6138C372.435 77.5278 372.207 77.5053 371.987 77.5492C371.767 77.593 371.564 77.7011 371.405 77.86C371.247 78.0188 371.138 78.2211 371.095 78.4414C371.051 78.6617 371.073 78.8901 371.159 79.0976C371.245 79.3051 371.391 79.4824 371.577 79.6072C371.764 79.732 371.984 79.7986 372.208 79.7986C372.358 79.8 372.506 79.7716 372.645 79.715C372.783 79.6584 372.909 79.5748 373.015 79.4691C373.12 79.3634 373.204 79.2376 373.26 79.0992C373.317 78.9608 373.345 78.8125 373.344 78.663Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M376.876 79.7915C377.497 79.7915 378.001 79.2877 378.001 78.6662C378.001 78.0448 377.497 77.541 376.876 77.541C376.254 77.541 375.75 78.0448 375.75 78.6662C375.75 79.2877 376.254 79.7915 376.876 79.7915Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M396.598 43.0938C396.745 43.8101 396.819 44.5398 396.816 45.2713C396.816 45.365 396.816 45.4484 396.816 45.5421",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M380.053 36.2186C381.398 35.3335 382.924 34.7598 384.518 34.5393C386.113 34.3189 387.737 34.4574 389.272 34.9446C390.806 35.4318 392.213 36.2555 393.388 37.3555C394.564 38.4555 395.479 39.8042 396.067 41.303",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M383.075 37.791C382.494 38.0179 381.942 38.3116 381.429 38.6662",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M394.004 45.4711C394.009 45.4052 394.009 45.339 394.004 45.2732C394.004 43.1427 393.157 41.0995 391.651 39.5931C390.145 38.0867 388.101 37.2404 385.971 37.2404C385.552 37.2379 385.134 37.2728 384.721 37.3445",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M391.399 45.4067V45.2712C391.399 43.8344 390.828 42.4564 389.812 41.4403C388.796 40.4243 387.418 39.8535 385.981 39.8535C384.798 39.8526 383.647 40.2447 382.71 40.9683",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M384.846 42.5117C384.5 42.6557 384.186 42.8643 383.918 43.1264",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M388.972 45.3463V45.2734C388.972 44.4803 388.657 43.7198 388.096 43.159C387.535 42.5982 386.774 42.2832 385.981 42.2832",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M318.677 43.7402C318.602 44.2543 318.564 44.7731 318.562 45.2926C318.562 45.3864 318.562 45.4697 318.562 45.5635",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M331.554 34.6563C330.845 34.5093 330.122 34.4359 329.397 34.4375C327.128 34.4366 324.916 35.1481 323.073 36.4715C321.23 37.795 319.849 39.6636 319.125 41.814",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M335.326 36.2183C334.638 35.7648 333.9 35.3908 333.127 35.1035",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M328.751 37.2695C328.96 37.2695 329.179 37.2695 329.397 37.2695C331.028 37.2711 332.62 37.7689 333.961 38.6969",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M321.375 45.4702C321.375 45.4077 321.375 45.3452 321.375 45.2723C321.375 43.6935 321.841 42.1498 322.714 40.8342C323.587 39.5186 324.828 38.4893 326.282 37.875",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M323.969 45.4067V45.2712C323.969 43.8344 324.54 42.4564 325.556 41.4403C326.572 40.4243 327.95 39.8535 329.387 39.8535C330.571 39.8526 331.721 40.2447 332.658 40.9683",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M326.418 45.3444C326.412 45.3204 326.412 45.2954 326.418 45.2714C326.415 44.6835 326.585 44.1077 326.909 43.6167C327.232 43.1256 327.693 42.7411 328.235 42.5117C328.776 42.2822 329.373 42.218 329.951 42.3272C330.529 42.4364 331.061 42.714 331.481 43.1252",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M193.351 235.881L186.057 221.451C185.967 221.265 185.807 221.122 185.612 221.054C185.417 220.985 185.202 220.997 185.016 221.087C184.833 221.181 184.693 221.341 184.626 221.535C184.558 221.729 184.567 221.941 184.651 222.129L191.631 236.715C191.487 236.859 191.389 237.043 191.348 237.243C191.307 237.443 191.326 237.651 191.402 237.84L198.779 251.676C198.977 252.062 199.612 252.145 200.196 251.864C200.779 251.582 201.102 251.02 200.915 250.624L194.445 236.34C194.325 236.167 194.158 236.032 193.964 235.951C193.771 235.87 193.558 235.846 193.351 235.881Z",
    fill: "#2E353A"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M233.744 235.885L241.037 221.455C241.078 221.354 241.139 221.263 241.217 221.187C241.294 221.111 241.387 221.051 241.489 221.013C241.59 220.974 241.699 220.957 241.808 220.962C241.916 220.967 242.023 220.994 242.12 221.042C242.218 221.091 242.304 221.158 242.375 221.241C242.445 221.324 242.497 221.421 242.529 221.525C242.56 221.629 242.569 221.739 242.556 221.847C242.544 221.955 242.509 222.059 242.454 222.153L235.484 236.739C235.626 236.885 235.723 237.069 235.762 237.269C235.8 237.469 235.78 237.676 235.702 237.864L228.326 251.7C228.128 252.086 227.503 252.169 226.909 251.888C226.315 251.606 226.002 251.044 226.19 250.648L232.66 236.364C232.776 236.189 232.94 236.051 233.132 235.967C233.324 235.882 233.536 235.853 233.744 235.885Z",
    fill: "#2E353A"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M236.526 252.322H190.725L194.153 246.498H233.087L236.526 252.322Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M236.526 252.322H190.725V258.157H236.526V252.322Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M212.834 253.957H195.216C194.508 253.957 193.934 254.531 193.934 255.239V255.249C193.934 255.957 194.508 256.53 195.216 256.53H212.834C213.541 256.53 214.115 255.957 214.115 255.249V255.239C214.115 254.531 213.541 253.957 212.834 253.957Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M223.481 256.221C224.103 256.221 224.606 255.717 224.606 255.096C224.606 254.474 224.103 253.971 223.481 253.971C222.86 253.971 222.356 254.474 222.356 255.096C222.356 255.717 222.86 256.221 223.481 256.221Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M229.274 255.095C229.276 254.87 229.211 254.649 229.087 254.46C228.963 254.272 228.785 254.125 228.577 254.038C228.37 253.95 228.14 253.927 227.919 253.971C227.698 254.014 227.495 254.122 227.335 254.282C227.176 254.441 227.067 254.645 227.024 254.866C226.98 255.087 227.004 255.316 227.091 255.524C227.178 255.732 227.325 255.909 227.514 256.033C227.702 256.157 227.923 256.222 228.148 256.22C228.447 256.22 228.733 256.102 228.944 255.891C229.155 255.68 229.274 255.394 229.274 255.095Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M232.806 256.221C233.427 256.221 233.931 255.717 233.931 255.096C233.931 254.474 233.427 253.971 232.806 253.971C232.184 253.971 231.681 254.474 231.681 255.096C231.681 255.717 232.184 256.221 232.806 256.221Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M247.33 212.303C248.977 213.253 250.346 214.619 251.298 216.265C252.251 217.911 252.754 219.778 252.758 221.68C252.758 221.773 252.758 221.857 252.758 221.95",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M235.983 212.638C237.748 211.481 239.812 210.866 241.922 210.867C243.117 210.863 244.304 211.06 245.433 211.451",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M240.516 213.785C239.394 213.996 238.329 214.439 237.39 215.087",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M249.997 221.9C249.997 221.838 249.997 221.775 249.997 221.702C249.994 219.71 249.252 217.79 247.914 216.313C246.576 214.837 244.738 213.91 242.756 213.711",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M245.829 217.929C245.326 217.407 244.723 216.991 244.055 216.708C243.387 216.425 242.668 216.281 241.943 216.283C240.758 216.284 239.606 216.672 238.661 217.388",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M247.33 221.829C247.33 221.829 247.33 221.745 247.33 221.693C247.325 220.977 247.18 220.269 246.902 219.609",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M241.193 218.775C240.688 218.904 240.224 219.163 239.849 219.526",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M244.902 221.766C244.902 221.766 244.902 221.766 244.902 221.693C244.911 221.031 244.7 220.386 244.302 219.858C243.904 219.329 243.342 218.949 242.704 218.775",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M174.649 219.877C174.544 220.476 174.492 221.082 174.493 221.69C174.493 221.784 174.493 221.867 174.493 221.961",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M181.056 211.734C179.724 212.312 178.52 213.15 177.515 214.198C176.51 215.246 175.723 216.484 175.201 217.84",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M191.256 212.638C189.495 211.482 187.435 210.866 185.328 210.867C184.596 210.865 183.867 210.938 183.15 211.086",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M179.264 216.428C180.561 214.938 182.361 213.977 184.321 213.73C186.281 213.482 188.264 213.964 189.891 215.084",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M177.305 221.902C177.305 221.839 177.305 221.777 177.305 221.704C177.306 220.515 177.569 219.341 178.076 218.266",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M181.452 217.909C182.376 216.966 183.611 216.393 184.927 216.298C186.243 216.202 187.549 216.589 188.599 217.388",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M179.92 221.827C179.92 221.827 179.92 221.743 179.92 221.691C179.918 220.883 180.1 220.085 180.452 219.357",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M183.369 219.432C183.936 218.949 184.662 218.693 185.407 218.714C186.152 218.735 186.862 219.032 187.401 219.546",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M182.348 221.765C182.348 221.765 182.348 221.765 182.348 221.692C182.348 221.201 182.47 220.718 182.702 220.285",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2443 148.021L16.9512 133.591C16.9102 133.491 16.849 133.399 16.7712 133.323C16.6934 133.247 16.6008 133.188 16.4992 133.149C16.3975 133.111 16.289 133.093 16.1803 133.099C16.0717 133.104 15.9652 133.131 15.8677 133.179C15.7701 133.227 15.6835 133.295 15.6132 133.378C15.5429 133.461 15.4905 133.558 15.4592 133.662C15.428 133.766 15.4185 133.875 15.4314 133.983C15.4443 134.091 15.4793 134.196 15.5342 134.289L22.5044 148.876C22.3594 149.022 22.2582 149.206 22.2122 149.406C22.1661 149.607 22.1771 149.817 22.2439 150.011L29.6203 163.847C29.8183 164.233 30.4434 164.316 31.0373 164.024C31.6311 163.733 31.9437 163.191 31.7457 162.795L25.2861 148.511C25.1743 148.341 25.0179 148.206 24.8341 148.12C24.6502 148.033 24.4462 147.999 24.2443 148.021Z",
    fill: "#2E353A"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6272 148.022L71.9203 133.592C72.0103 133.406 72.1705 133.263 72.3658 133.194C72.5612 133.126 72.7756 133.138 72.9622 133.227C73.1448 133.321 73.2843 133.482 73.3522 133.676C73.42 133.869 73.4109 134.082 73.3268 134.269L66.3463 148.855C66.5057 148.996 66.6181 149.183 66.6683 149.39C66.7186 149.596 66.7044 149.813 66.6276 150.012L59.2512 163.848C59.0532 164.233 58.4177 164.317 57.8342 164.025C57.2508 163.733 56.9278 163.192 57.1153 162.796L63.5854 148.512C63.6963 148.341 63.8526 148.205 64.0367 148.119C64.2207 148.032 64.4252 147.999 64.6272 148.022Z",
    fill: "#2E353A"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4197 164.461H21.6191L25.0469 158.627H63.9815L67.4197 164.461Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M67.409 164.463H21.6084V170.297H67.409V164.463Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7068 168.673H26.1096C25.7688 168.67 25.4429 168.533 25.2028 168.291C24.9628 168.049 24.8281 167.722 24.8281 167.381C24.8281 167.041 24.9631 166.715 25.2035 166.475C25.4438 166.235 25.7698 166.1 26.1096 166.1H43.7068C44.0467 166.1 44.3726 166.235 44.613 166.475C44.8533 166.715 44.9883 167.041 44.9883 167.381C44.9883 167.722 44.8536 168.049 44.6136 168.291C44.3736 168.533 44.0476 168.67 43.7068 168.673Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3752 168.35C54.9967 168.35 55.5004 167.846 55.5004 167.225C55.5004 166.603 54.9967 166.1 54.3752 166.1C53.7538 166.1 53.25 166.603 53.25 167.225C53.25 167.846 53.7538 168.35 54.3752 168.35Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0324 168.35C59.6539 168.35 60.1577 167.846 60.1577 167.225C60.1577 166.603 59.6539 166.1 59.0324 166.1C58.411 166.1 57.9072 166.603 57.9072 167.225C57.9072 167.846 58.411 168.35 59.0324 168.35Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8255 167.222C64.8255 166.996 64.7586 166.777 64.6333 166.59C64.5081 166.403 64.3301 166.257 64.122 166.171C63.9139 166.086 63.685 166.064 63.4644 166.109C63.2439 166.153 63.0415 166.262 62.8831 166.422C62.7247 166.582 62.6174 166.785 62.5748 167.006C62.5321 167.227 62.5561 167.456 62.6437 167.663C62.7312 167.871 62.8784 168.047 63.0665 168.171C63.2546 168.294 63.4752 168.359 63.7003 168.357C63.8489 168.357 63.9961 168.328 64.1333 168.271C64.2705 168.213 64.395 168.13 64.4996 168.024C64.6042 167.918 64.6869 167.793 64.7428 167.655C64.7988 167.518 64.8268 167.37 64.8255 167.222Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0474 130.277C83.4416 131.42 83.6423 132.621 83.6412 133.83C83.6412 133.924 83.6412 134.007 83.6412 134.101",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9624 123.203C76.6205 123.538 78.1778 124.255 79.5106 125.297C80.8435 126.338 81.9153 127.676 82.641 129.204",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8779 124.776C68.3238 123.822 69.9788 123.232 71.7018 123.057",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8487 128.54C77.5527 127.057 75.7558 126.104 73.8014 125.862C71.8469 125.619 69.8717 126.106 68.2529 127.227",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8281 134.031C80.8336 133.965 80.8336 133.899 80.8281 133.833C80.8296 132.547 80.5224 131.278 79.9321 130.135",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6908 128.539C70.9028 128.72 70.1656 129.076 69.5342 129.581",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2233 133.965V133.829C78.2239 132.597 77.8038 131.402 77.0327 130.442C76.2616 129.481 75.1857 128.813 73.9829 128.547",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1607 131.988C74.9041 131.658 74.5807 131.386 74.2117 131.19C73.8428 130.993 73.4365 130.877 73.0195 130.849C72.6025 130.82 72.1842 130.88 71.792 131.024C71.3997 131.169 71.0423 131.394 70.7432 131.686",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7959 133.904V133.832C75.7976 133.539 75.7554 133.247 75.6709 132.967",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M14.326 123.162C11.8203 123.607 9.55128 124.921 7.91679 126.871C6.2823 128.822 5.3866 131.286 5.38672 133.831C5.38672 133.925 5.38672 134.008 5.38672 134.102",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1503 124.78C20.5929 123.759 18.7988 123.156 16.9409 123.029",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9932 126.049C18.9888 126.265 19.9356 126.664 20.7854 127.226",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19971 134.032C8.19971 133.969 8.19971 133.907 8.19971 133.834C8.19971 131.703 9.04602 129.66 10.5525 128.154C12.0589 126.647 14.1021 125.801 16.2325 125.801",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0444 130.394C12.9303 129.31 14.2034 128.613 15.5939 128.452C16.9844 128.291 18.3832 128.677 19.4938 129.529",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8047 133.965V133.83C10.8043 133.113 10.9496 132.405 11.2319 131.746",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7534 130.891C17.3341 130.997 17.8705 131.273 18.2954 131.682",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2422 133.904C13.2422 133.904 13.2422 133.904 13.2422 133.831C13.2446 133.124 13.4968 132.44 13.9543 131.901C14.4118 131.361 15.0452 131.001 15.7427 130.883",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M262.562 264.242H169.721V327.848H262.562V264.242Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M276.492 355.97H155.802L169.721 327.85H262.562L276.492 355.97Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M256.936 269.273H175.347V322.815H256.936V269.273Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M228.368 290.903L216.168 276.473L203.967 290.903H209.072V313.501H223.263V290.903H228.368Z",
    fill: "#026CE3"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M212.271 336.756L212.427 333.328H207.531L207.197 336.756H212.271Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M222.408 336.756L222.242 333.328H217.334L217.345 336.756H222.408Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M248.809 340.415H254.06L252.82 336.758H247.757L248.809 340.415Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M207.197 336.756L207.53 333.328H202.623L202.133 336.756H207.197Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M197.06 336.756L197.716 333.328H192.809L191.996 336.756H197.06Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M242.683 336.756L241.86 333.328H236.953L237.62 336.756H242.683Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M247.757 336.756L246.768 333.328H241.86L242.683 336.756H247.757Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M191.996 336.756L192.809 333.328H187.902L186.922 336.756H191.996Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M227.482 336.756L227.149 333.328H222.242L222.408 336.756H227.482Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M252.821 336.756L251.675 333.328H246.768L247.757 336.756H252.821Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M237.62 336.756L236.953 333.328H232.056L232.546 336.756H237.62Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M232.546 336.756L232.056 333.328H227.149L227.482 336.756H232.546Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M217.345 336.756L217.334 333.328H212.427L212.271 336.756H217.345Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M181.859 336.758H176.785L175.389 340.415H180.629L181.859 336.758Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M182.994 333.328H178.097L176.785 336.756H181.859L182.994 333.328Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M186.922 336.756L187.902 333.328H182.995L181.859 336.756H186.922Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M173.889 344.34L172.274 348.559H177.91L179.317 344.34H173.889Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M180.63 340.414H175.389L173.889 344.342H179.317L180.63 340.414Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M179.317 344.34L177.91 348.559H183.547L184.755 344.34H179.317Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M202.134 336.756L202.624 333.328H197.716L197.06 336.756H202.134Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M201.612 340.415L202.133 336.758H197.059L196.361 340.415H201.612Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M196.362 340.415L197.06 336.758H191.996L191.121 340.415H196.362Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M206.853 340.415L207.197 336.758H202.133L201.612 340.415H206.853Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M186.922 336.758H181.859L180.629 340.415H185.88L186.922 336.758Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M249.945 344.342H255.373L254.061 340.414H248.81L249.945 344.342Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M191.121 340.415L191.997 336.758H186.923L185.881 340.415H191.121Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M180.629 340.414L179.316 344.342H184.755L185.88 340.414H180.629Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M238.318 340.415L237.62 336.758H232.546L233.077 340.415H238.318Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M233.077 340.415L232.545 336.758H227.482L227.836 340.415H233.077Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M248.81 340.415L247.757 336.758H242.684L243.569 340.415H248.81Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M217.345 340.415V336.758H212.271L212.094 340.415H217.345Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M227.836 340.415L227.482 336.758H222.408L222.585 340.415H227.836Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M222.585 340.415L222.408 336.758H217.345V340.415H222.585Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M212.094 340.415L212.271 336.758H207.197L206.854 340.415H212.094Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M227.837 340.414L228.212 344.342H233.651L233.078 340.414H227.837Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M233.077 340.414L233.65 344.342H239.078L238.318 340.414H233.077Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M185.881 340.414L184.755 344.342H190.184L191.121 340.414H185.881Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M238.317 340.414L239.078 344.342H244.506L243.568 340.414H238.317Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M217.345 340.414V344.342H222.783L222.585 340.414H217.345Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M243.569 340.414L244.507 344.342H249.945L248.809 340.414H243.569Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M222.585 340.414L222.783 344.342H228.212L227.836 340.414H222.585Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M196.362 340.414L195.612 344.342H201.05L201.613 340.414H196.362Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M191.121 340.414L190.184 344.342H195.612L196.362 340.414H191.121Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M212.094 340.414L211.917 344.342H217.345V340.414H212.094Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M206.853 340.414L206.478 344.342H211.917L212.094 340.414H206.853Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M201.612 340.414L201.05 344.342H206.478L206.853 340.414H201.612Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M243.569 340.415L242.683 336.758H237.62L238.318 340.415H243.569Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M182.994 333.331L184.172 329.82H179.431L178.098 333.331H182.994Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M178.098 333.328H173.566L172.107 336.756H176.785L178.098 333.328Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M179.431 329.82H175.066L173.565 333.331H178.098L179.431 329.82Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M176.785 336.758H172.107L170.544 340.415H175.389L176.785 336.758Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M175.389 340.414H170.544L168.867 344.342H173.889L175.389 340.414Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M173.889 344.34H168.867L167.075 348.559H172.274L173.889 344.34Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M257.894 336.758L259.301 340.415H263.937L262.374 336.758H257.894Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M260.812 344.342H265.615L263.937 340.414H259.301L260.812 344.342Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M262.427 348.559H267.407L265.615 344.34H260.812L262.427 348.559Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M222.242 333.331L222.075 329.82H217.334V333.331H222.242Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M257.894 336.756H262.374L260.916 333.328H256.582L257.894 336.756Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M255.373 344.342H260.812L259.301 340.414H254.061L255.373 344.342Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M187.902 333.331L188.912 329.82H184.172L182.995 333.331H187.902Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M251.675 333.328L252.821 336.756H257.895L256.582 333.328H251.675Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M260.916 333.331L259.426 329.82H255.227L256.582 333.331H260.916Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M256.582 333.331L255.228 329.82H250.498L251.675 333.331H256.582Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M239.078 344.34L239.891 348.559H245.527L244.506 344.34H239.078Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M256.79 348.559H262.426L260.812 344.34H255.373L256.79 348.559Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M251.675 333.331L250.497 329.82H245.757L246.767 333.331H251.675Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M249.945 344.34L251.153 348.559H256.79L255.373 344.34H249.945Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M244.507 344.34L245.528 348.559H251.154L249.945 344.34H244.507Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M254.061 340.415H259.301L257.895 336.758H252.821L254.061 340.415Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M207.531 333.331L207.864 329.82H203.124L202.624 333.331H207.531Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M246.767 333.331L245.757 329.82H241.016L241.86 333.331H246.767Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M202.624 333.331L203.124 329.82H198.383L197.716 333.331H202.624Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M217.334 333.331V329.82H212.594L212.427 333.331H217.334Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M197.716 333.331L198.383 329.82H193.643L192.809 333.331H197.716Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M192.809 333.331L193.643 329.82H188.912L187.902 333.331H192.809Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M212.427 333.331L212.594 329.82H207.864L207.53 333.331H212.427Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M241.86 333.331L241.016 329.82H236.286L236.953 333.331H241.86Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M236.953 333.331L236.286 329.82H231.545L232.056 333.331H236.953Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M227.149 333.331L226.805 329.82H222.075L222.241 333.331H227.149Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M239.078 344.34H233.65H228.211H222.783H217.345H211.916H206.478H201.05H195.611H190.183H184.755L183.546 348.559H189.183H194.809H200.446H206.082H211.719H217.345H222.981H228.618H234.254H239.891L239.078 344.34Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M232.056 333.331L231.546 329.82H226.805L227.149 333.331H232.056Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M276.544 355.969H155.802V357.677H276.544V355.969Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M296.724 264.242H367.572V327.848H296.724C296.277 327.848 295.848 327.67 295.531 327.354C295.214 327.037 295.037 326.608 295.037 326.16V265.94C295.035 265.718 295.078 265.497 295.162 265.291C295.246 265.085 295.37 264.898 295.527 264.74C295.684 264.582 295.871 264.457 296.076 264.372C296.282 264.286 296.502 264.242 296.724 264.242Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M370.01 264.242H296.943V327.848H370.01V264.242Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M366.02 269.273H302.57V322.815H366.02V269.273Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M324.241 290.903L333.701 276.473L343.161 290.903H339.202V313.501H328.2V290.903H324.241Z",
    fill: "#026CE3"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M296.943 327.85L352.329 343.863H427L370.01 327.85H296.943Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M356.091 334.184L349.162 332.215L346.13 332.184L353.038 334.163L356.091 334.184Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M362.123 334.236L355.174 332.277L352.184 332.246L359.112 334.215L362.123 334.236Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M384.023 336.311L386.92 336.332L379.72 334.363L376.834 334.342L384.023 336.311Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M353.038 334.163L346.13 332.184L343.078 332.152L349.964 334.142L353.038 334.163Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M346.881 334.121L339.994 332.131L336.899 332.1L343.765 334.1L346.881 334.121Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M373.938 334.318L366.937 332.38L364.03 332.359L371.01 334.297L373.938 334.318Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M376.834 334.338L369.823 332.41L366.937 332.379L373.938 334.317L376.834 334.338Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 334.102L336.9 332.102L333.774 332.07L340.619 334.081L343.765 334.102Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M365.103 334.257L358.143 332.298L355.174 332.277L362.123 334.236L365.103 334.257Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M379.721 334.36L372.698 332.443L369.823 332.412L376.835 334.34L379.721 334.36Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M371.01 334.299L364.03 332.361L361.092 332.33L368.072 334.278L371.01 334.299Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M368.072 334.278L361.092 332.33L358.143 332.299L365.103 334.258L368.072 334.278Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M359.112 334.213L352.184 332.244L349.162 332.213L356.091 334.182L359.112 334.213Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M337.462 334.048L334.274 334.027L341.275 336.101L344.474 336.122L337.462 334.048Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M330.627 332.037L327.46 332.006L334.274 334.027L337.462 334.048L330.627 332.037Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M340.619 334.079L333.774 332.068L330.627 332.037L337.462 334.048L340.619 334.079Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M348.454 338.229L355.841 340.416H359.071L351.673 338.239L348.454 338.229Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M344.474 336.12L341.275 336.1L348.454 338.225L351.673 338.235L344.474 336.12Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M351.673 338.236L359.071 340.414H362.28L354.861 338.247L351.673 338.236Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M349.964 334.142L343.078 332.152L339.994 332.131L346.88 334.121L349.964 334.142Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M357.039 336.184L349.964 334.142L346.88 334.121L353.934 336.163L357.039 336.184Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M353.934 336.164L346.881 334.122L343.766 334.102L350.809 336.154L353.934 336.164Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M360.123 336.195L353.038 334.163L349.964 334.143L357.039 336.185L360.123 336.195Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M340.619 334.08L337.462 334.049L344.474 336.122L347.651 336.133L340.619 334.08Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M391.399 338.342L394.296 338.353L386.919 336.331L384.023 336.311L391.399 338.342Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M350.809 336.153L343.766 334.101L340.619 334.08L347.652 336.133L350.809 336.153Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M344.474 336.119L351.673 338.234L354.861 338.245L347.651 336.13L344.474 336.119Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M378.178 336.286L371.01 334.296L368.072 334.275L375.219 336.265L378.178 336.286Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M375.22 336.267L368.072 334.277L365.103 334.256L372.25 336.256L375.22 336.267Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M384.023 336.31L376.834 334.341L373.938 334.32L381.116 336.3L384.023 336.31Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M366.228 336.224L359.112 334.213L356.09 334.182L363.185 336.203L366.228 336.224Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M372.25 336.258L365.103 334.257L362.123 334.236L369.249 336.237L372.25 336.258Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M369.25 336.236L362.123 334.236L359.112 334.215L366.228 336.226L369.25 336.236Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M363.186 336.204L356.091 334.183L353.038 334.162L360.123 336.194L363.186 336.204Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M372.25 336.258L379.574 338.31L382.565 338.321L375.219 336.268L372.25 336.258Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M375.22 336.266L382.565 338.318L385.524 338.329L378.179 336.286L375.22 336.266Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M347.652 336.133L354.862 338.248L358.039 338.258L350.809 336.154L347.652 336.133Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M378.178 336.287L385.523 338.329H388.472L381.116 336.298L378.178 336.287Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M366.228 336.225L373.532 338.287L376.563 338.298L369.249 336.235L366.228 336.225Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M381.116 336.299L388.472 338.33L391.399 338.341L384.023 336.309L381.116 336.299Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M369.25 336.238L376.563 338.301L379.574 338.312L372.25 336.259L369.25 336.238Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M353.934 336.164L361.175 338.269H364.301L357.039 336.185L353.934 336.164Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M350.809 336.152L358.039 338.257L361.175 338.267L353.934 336.163L350.809 336.152Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M363.186 336.205L370.479 338.289H373.531L366.228 336.226L363.186 336.205Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M360.123 336.193L367.405 338.277L370.479 338.287L363.186 336.204L360.123 336.193Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M357.039 336.186L364.3 338.269L367.405 338.28L360.123 336.196L357.039 336.186Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M381.116 336.297L373.938 334.318L371.01 334.297L378.178 336.287L381.116 336.297Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M330.627 332.039L323.345 329.893L320.198 329.861L327.46 332.008L330.627 332.039Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M327.46 332.008L324.511 331.977L331.315 334.008L334.274 334.029L327.46 332.008Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M320.198 329.862L317.271 329.82L324.511 331.977L327.46 332.008L320.198 329.862Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M334.274 334.029L331.315 334.008L338.295 336.092L341.275 336.102L334.274 334.029Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M341.276 336.102L338.296 336.092L345.464 338.228H348.454L341.276 336.102Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M348.454 338.229H345.464L352.83 340.416H355.841L348.454 338.229Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M382.585 334.383L389.795 336.342L392.317 336.362L385.096 334.404L382.585 334.383Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M397.182 338.351L399.714 338.361L392.316 336.361L389.795 336.34L397.182 338.351Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M404.766 340.413H407.298L399.713 338.36L397.182 338.35L404.766 340.413Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M355.174 332.28L347.756 330.186L344.776 330.154L352.184 332.248L355.174 332.28Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M382.586 334.382L385.096 334.403L378.053 332.496L375.542 332.465L382.586 334.382Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M394.296 338.353H397.182L389.795 336.342L386.92 336.332L394.296 338.353Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M333.774 332.07L326.47 329.934L323.345 329.893L330.627 332.039L333.774 332.07Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M372.698 332.445L379.72 334.362L382.585 334.383L375.542 332.466L372.698 332.445Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M378.053 332.495L370.531 330.453L368.041 330.422L375.542 332.464L378.053 332.495Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M375.543 332.462L368.041 330.42L365.197 330.389L372.698 332.441L375.543 332.462Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M385.523 338.33L393.067 340.414H396.025L388.472 338.33H385.523Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M401.871 340.413H404.767L397.182 338.35H394.296L401.871 340.413Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M372.698 332.445L365.197 330.393L362.342 330.361L369.822 332.414L372.698 332.445Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M391.399 338.342L398.953 340.415H401.87L394.296 338.352L391.399 338.342Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M388.472 338.33L396.025 340.414H398.953L391.399 338.341L388.472 338.33Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M386.92 336.33L389.795 336.341L382.585 334.382L379.72 334.361L386.92 336.33Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M346.13 332.181L338.764 330.077L335.722 330.035L343.078 332.15L346.13 332.181Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M369.822 332.414L362.342 330.362L359.466 330.32L366.936 332.383L369.822 332.414Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M343.078 332.154L335.722 330.039L332.659 330.008L339.994 332.133L343.078 332.154Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M352.183 332.245L344.776 330.151L341.786 330.109L349.162 332.214L352.183 332.245Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M339.994 332.13L332.659 330.005L329.575 329.963L336.9 332.099L339.994 332.13Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M336.899 332.101L329.575 329.965L326.47 329.934L333.774 332.069L336.899 332.101Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M349.162 332.216L341.786 330.111L338.764 330.08L346.13 332.185L349.162 332.216Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M366.936 332.381L359.466 330.318L356.57 330.287L364.03 332.36L366.936 332.381Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M364.03 332.36L356.57 330.287L353.653 330.256L361.092 332.329L364.03 332.36Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M358.143 332.297L350.714 330.213L347.755 330.182L355.174 332.276L358.143 332.297Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M385.524 338.331L382.565 338.321L379.574 338.311L376.563 338.3L373.532 338.29H370.479L367.405 338.279L364.301 338.269H361.175L358.039 338.258L354.861 338.248L362.279 340.415H365.457H368.624H371.76H374.865H377.96H381.023H384.065H387.086H390.087H393.067L385.524 338.331Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M361.092 332.33L353.653 330.257L350.715 330.215L358.143 332.299L361.092 332.33Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M296.943 327.85V329.975L352.308 346.593L352.329 343.863L296.943 327.85Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M427 343.865H352.33V346.585H427V343.865Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M132.818 327.85H61.9709L61.9709 264.243H132.818C133.266 264.243 133.695 264.421 134.011 264.738C134.328 265.054 134.506 265.484 134.506 265.931V326.151C134.507 326.374 134.465 326.595 134.38 326.8C134.296 327.006 134.172 327.194 134.015 327.352C133.858 327.509 133.672 327.635 133.466 327.72C133.261 327.806 133.041 327.85 132.818 327.85Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5328 327.85H132.599V264.243H59.5328L59.5328 327.85Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5233 322.816H126.973V269.275H63.5233L63.5233 322.816Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M101.333 290.903L91.8728 276.473L82.4126 290.903H86.3717V313.501H97.3738V290.903H101.333Z",
    fill: "#026CE3"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M132.599 327.85L77.2133 343.863H2.54248L59.5327 327.85H132.599Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4521 334.184L80.3806 332.215L83.4124 332.184L76.5048 334.163L73.4521 334.184Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4199 334.236L74.3692 332.277L77.3594 332.246L70.4309 334.215L67.4199 334.236Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5199 336.311L42.6235 336.332L49.8229 334.363L52.7088 334.342L45.5199 336.311Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5054 334.163L83.413 332.184L86.4656 332.152L79.5789 334.142L76.5054 334.163Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6621 334.121L89.5489 332.131L92.6432 332.1L85.7773 334.1L82.6621 334.121Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6055 334.318L62.6068 332.38L65.5136 332.359L58.5331 334.297L55.6055 334.318Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7085 334.338L59.7203 332.41L62.6063 332.379L55.6049 334.317L52.7085 334.338Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7778 334.102L92.6437 332.102L95.7694 332.07L88.9243 334.081L85.7778 334.102Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4404 334.257L71.4001 332.298L74.3694 332.277L67.4202 334.236L64.4404 334.257Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8228 334.36L56.845 332.443L59.7205 332.412L52.7087 334.34L49.8228 334.36Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5332 334.299L65.5137 332.361L68.4518 332.33L61.4713 334.278L58.5332 334.299Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4707 334.278L68.4512 332.33L71.3997 332.299L64.44 334.258L61.4707 334.278Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4312 334.213L77.3596 332.244L80.381 332.213L73.4526 334.182L70.4312 334.213Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0811 334.048L95.2692 334.027L88.2679 336.101L85.0693 336.122L92.0811 334.048Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9157 332.037L102.083 332.006L95.2692 334.027L92.0811 334.048L98.9157 332.037Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9243 334.079L95.7694 332.068L98.9159 332.037L92.0812 334.048L88.9243 334.079Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0893 338.229L73.7024 340.416H70.4727L77.8699 338.239L81.0893 338.229Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0689 336.12L88.2675 336.1L81.089 338.225L77.8696 338.235L85.0689 336.12Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8699 338.236L70.4726 340.414H67.2637L74.6714 338.247L77.8699 338.236Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5786 334.142L86.4654 332.152L89.5493 332.131L82.6625 334.121L79.5786 334.142Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5039 336.184L79.5782 334.142L82.6621 334.121L75.6087 336.163L72.5039 336.184Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6089 336.164L82.6623 334.122L85.7775 334.102L78.7345 336.154L75.6089 336.164Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4204 336.195L76.5051 334.163L79.5786 334.143L72.5043 336.185L69.4204 336.195Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9242 334.08L92.0811 334.049L85.0693 336.122L81.8916 336.133L88.9242 334.08Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1435 338.342L35.2471 338.353L42.6235 336.331L45.5199 336.311L38.1435 338.342Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7344 336.153L85.7774 334.101L88.9238 334.08L81.8912 336.133L78.7344 336.153Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0692 336.119L77.8699 338.234L74.6714 338.245L81.8915 336.13L85.0692 336.119Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3647 336.286L58.5328 334.296L61.4709 334.275L54.3237 336.265L51.3647 336.286Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3237 336.267L61.471 334.277L64.4403 334.256L57.2931 336.256L54.3237 336.267Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M45.52 336.31L52.7089 334.341L55.6053 334.32L48.4268 336.3L45.52 336.31Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3149 336.224L70.4309 334.213L73.4523 334.182L66.3572 336.203L63.3149 336.224Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2925 336.258L64.4397 334.257L67.4195 334.236L60.2931 336.237L57.2925 336.258Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2935 336.236L67.4198 334.236L70.4309 334.215L63.3149 336.226L60.2935 336.236Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3574 336.204L73.4526 334.183L76.5052 334.162L69.4205 336.194L66.3574 336.204Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M57.293 336.258L49.9687 338.31L46.9785 338.321L54.3237 336.268L57.293 336.258Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3236 336.266L46.9784 338.318L44.0195 338.329L51.3647 336.286L54.3236 336.266Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8913 336.133L74.6712 338.248L71.5039 338.258L78.7345 336.154L81.8913 336.133Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3645 336.287L44.0193 338.329H41.0708L48.4264 336.298L51.3645 336.287Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3153 336.225L56.0118 338.287L52.98 338.298L60.2939 336.235L63.3153 336.225Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4263 336.299L41.0707 338.33L38.1431 338.341L45.5195 336.309L48.4263 336.299Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2937 336.238L52.9798 338.301L49.9688 338.312L57.2931 336.259L60.2937 336.238Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6093 336.164L68.3683 338.269H65.2427L72.5045 336.185L75.6093 336.164Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7348 336.152L71.5042 338.257L68.3682 338.267L75.6092 336.163L78.7348 336.152Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M66.357 336.205L59.0639 338.289H56.0112L63.3147 336.226L66.357 336.205Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4201 336.193L62.1375 338.277L59.064 338.287L66.3571 336.204L69.4201 336.193Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5043 336.186L65.2425 338.269L62.1377 338.28L69.4204 336.196L72.5043 336.186Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4268 336.297L55.6052 334.318L58.5329 334.297L51.3648 336.287L48.4268 336.297Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9155 332.039L106.198 329.893L109.345 329.861L102.083 332.008L98.9155 332.039Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M102.083 332.008L105.031 331.977L98.2279 334.008L95.269 334.029L102.083 332.008Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M109.345 329.862L112.272 329.82L105.032 331.977L102.083 332.008L109.345 329.862Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2689 334.029L98.2278 334.008L91.2473 336.092L88.2676 336.102L95.2689 334.029Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2678 336.102L91.2476 336.092L84.0795 338.228H81.0894L88.2678 336.102Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M81.089 338.229H84.0792L76.7132 340.416H73.7021L81.089 338.229Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9576 334.383L39.7479 336.342L37.2266 336.362L44.4467 334.404L46.9576 334.383Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3608 338.351L29.8291 338.361L37.2264 336.361L39.7477 336.34L32.3608 338.351Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7764 340.413H22.2446L29.8294 338.36L32.3612 338.35L24.7764 340.413Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3691 332.28L81.7873 330.186L84.767 330.154L77.3593 332.248L74.3691 332.28Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9577 334.382L44.4468 334.403L51.4898 332.496L53.9903 332.465L46.9577 334.382Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2473 338.353H32.3613L39.7482 336.342L42.6237 336.332L35.2473 338.353Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M95.769 332.07L103.073 329.934L106.198 329.893L98.9155 332.039L95.769 332.07Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8449 332.445L49.8227 334.362L46.9575 334.383L53.9901 332.466L56.8449 332.445Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4897 332.495L59.012 330.453L61.5021 330.422L53.9902 332.464L51.4897 332.495Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9902 332.462L61.5021 330.42L64.3464 330.389L56.845 332.441L53.9902 332.462Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0196 338.33L36.4765 340.414H33.5176L41.0711 338.33H44.0196Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6723 340.413H24.7759L32.3607 338.35H35.2467L27.6723 340.413Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8452 332.445L64.3467 330.393L67.2014 330.361L59.7208 332.414L56.8452 332.445Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1436 338.342L30.5901 340.415H27.6729L35.2472 338.352L38.1436 338.342Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M41.071 338.33L33.5175 340.414H30.5898L38.1434 338.341L41.071 338.33Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6231 336.33L39.7476 336.341L46.9573 334.382L49.8224 334.361L42.6231 336.33Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4126 332.181L90.7786 330.077L93.8209 330.035L86.4653 332.15L83.4126 332.181Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7202 332.414L67.2008 330.362L70.0764 330.32L62.6062 332.383L59.7202 332.414Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4648 332.154L93.8205 330.039L96.8835 330.008L89.5488 332.133L86.4648 332.154Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3594 332.245L84.7671 330.151L87.7572 330.109L80.3808 332.214L77.3594 332.245Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5488 332.13L96.8836 330.005L99.9675 329.963L92.6432 332.099L89.5488 332.13Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6436 332.101L99.9679 329.965L103.073 329.934L95.7692 332.069L92.6436 332.101Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3809 332.216L87.7573 330.111L90.7787 330.08L83.4127 332.185L80.3809 332.216Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6064 332.381L70.0766 330.318L72.973 330.287L65.5133 332.36L62.6064 332.381Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5132 332.36L72.973 330.287L75.8902 330.256L68.4513 332.329L65.5132 332.36Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3999 332.297L78.8284 330.213L81.7873 330.182L74.3692 332.276L71.3999 332.297Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0192 338.331L46.9781 338.321L49.9683 338.311L52.9793 338.3L56.0111 338.29H59.0638L62.1373 338.279L65.2421 338.269H68.3677L71.5037 338.258L74.671 338.248L67.2633 340.415H64.0856H60.9183H57.7927H54.6775H51.5832H48.5201H45.4778H42.4564H39.4558H36.4761L44.0192 338.331Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4512 332.33L75.8901 330.257L78.8282 330.215L71.3997 332.299L68.4512 332.33Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M132.599 327.85V329.975L77.2238 346.593L77.2134 343.863L132.599 327.85Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54259 346.592H77.2134V343.873H2.54259V346.592Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginimage);
export default __webpack_public_path__ + "static/media/loginimage.d9c9227444b22fc01bb735b380f83738.svg";
export { ForwardRef as ReactComponent };